import "core-js/modules/es.array.flat";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.reduce-right";
import "core-js/modules/es.array.unscopables.flat";
import _defineProperty2 from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _construct from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/construct";
import _toConsumableArray from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import React, { forwardRef, useRef, useState, useEffect, useLayoutEffect, useMemo, Children } from 'react';
import { useFrame, useUpdate, useThree, useLoader, extend, addEffect, addAfterEffect, applyProps } from 'react-three-fiber';
import mergeRefs from 'react-merge-refs';
import { Vector2, AudioListener, AudioLoader, PMREMGenerator, CubeTextureLoader, WebGLMultisampleRenderTarget, RGBAFormat, sRGBEncoding, DefaultLoadingManager, TextureLoader, Vector3, PerspectiveCamera as PerspectiveCamera$1, OrthographicCamera as OrthographicCamera$1, Matrix4, Ray, Sphere as Sphere$1, Color, Raycaster, Camera, BufferGeometry, Geometry, MeshPhysicalMaterial, MeshStandardMaterial, ShaderMaterial, ShaderChunk, Spherical, AdditiveBlending, WebGLRenderTarget, PlaneBufferGeometry, Mesh, MeshDepthMaterial, Shape, RepeatWrapping } from 'three';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial';
import { Line2 } from 'three/examples/jsm/lines/Line2';
import { Text as Text$1 } from 'troika-three-text';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass';
import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader';
import { DeviceOrientationControls as DeviceOrientationControls$1 } from 'three/examples/jsm/controls/DeviceOrientationControls';
import { FlyControls as FlyControls$1 } from 'three/examples/jsm/controls/FlyControls';
import { MapControls as MapControls$1, OrbitControls as OrbitControls$1 } from 'three/examples/jsm/controls/OrbitControls';
import { TrackballControls as TrackballControls$1 } from 'three/examples/jsm/controls/TrackballControls';
import { TransformControls as TransformControls$1 } from 'three/examples/jsm/controls/TransformControls';
import pick from 'lodash.pick';
import omit from 'lodash.omit';
import { PointerLockControls as PointerLockControls$1 } from 'three/examples/jsm/controls/PointerLockControls';
import create$1 from 'zustand';
import { useTransition, a } from '@react-spring/web';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import ReactDOM from 'react-dom';
import { Reflector as Reflector$1 } from 'three/examples/jsm/objects/Reflector';
import StatsImpl from 'three/examples/js/libs/stats.min';
import { getGPUTier } from 'detect-gpu';
import { SimplifyModifier } from 'three/examples/jsm/modifiers/SimplifyModifier';
import { SubdivisionModifier } from 'three/examples/jsm/modifiers/SubdivisionModifier';
import { TessellateModifier } from 'three/examples/jsm/modifiers/TessellateModifier';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { Sky as Sky$1 } from 'three/examples/jsm/objects/Sky';
import { HorizontalBlurShader } from 'three/examples/jsm/shaders/HorizontalBlurShader';
import { VerticalBlurShader } from 'three/examples/jsm/shaders/VerticalBlurShader';

function create(type) {
  var El = type + 'BufferGeometry';
  return /*#__PURE__*/forwardRef(function (_ref, ref) {
    var args = _ref.args,
        children = _ref.children,
        props = _objectWithoutPropertiesLoose(_ref, ["args", "children"]);

    return /*#__PURE__*/React.createElement("mesh", _extends({
      ref: ref
    }, props), /*#__PURE__*/React.createElement(El, {
      attach: "geometry",
      args: args
    }), children);
  });
}

var Box = create('box');
var Circle = create('circle');
var Cone = create('cone');
var Cylinder = create('cylinder');
var Sphere = create('sphere');
var Plane = create('plane');
var Tube = create('tube');
var Torus = create('torus');
var TorusKnot = create('torusKnot');
var Tetrahedron = create('tetrahedron');
var Ring = create('ring');
var Polyhedron = create('polyhedron');
var Icosahedron = create('icosahedron');
var Octahedron = create('octahedron');
var Dodecahedron = create('dodecahedron');
var Extrude = create('extrude');
var Lathe = create('lathe');
var Parametric = create('parametric');
var Billboard = /*#__PURE__*/forwardRef(function Billboard(_ref, ref) {
  var _ref$follow = _ref.follow,
      follow = _ref$follow === void 0 ? true : _ref$follow,
      _ref$lockX = _ref.lockX,
      lockX = _ref$lockX === void 0 ? false : _ref$lockX,
      _ref$lockY = _ref.lockY,
      lockY = _ref$lockY === void 0 ? false : _ref$lockY,
      _ref$lockZ = _ref.lockZ,
      lockZ = _ref$lockZ === void 0 ? false : _ref$lockZ,
      props = _objectWithoutPropertiesLoose(_ref, ["follow", "lockX", "lockY", "lockZ"]);

  var localRef = useRef();
  useFrame(function (_ref2) {
    var camera = _ref2.camera;
    if (!follow) return;

    if (localRef.current) {
      var prev = {
        x: localRef.current.rotation.x,
        y: localRef.current.rotation.y,
        z: localRef.current.rotation.z
      };
      localRef.current.lookAt(camera.position); // readjust any axis that is locked

      if (lockX) localRef.current.rotation.x = prev.x;
      if (lockY) localRef.current.rotation.y = prev.y;
      if (lockZ) localRef.current.rotation.z = prev.z;
    }
  });
  return /*#__PURE__*/React.createElement(Plane, _extends({
    ref: mergeRefs([localRef, ref])
  }, props));
});
var Detailed = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      distances = _ref.distances,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "distances"]);

  var lod = useUpdate(function (lod) {
    lod.levels.length = 0;
    lod.children.forEach(function (object, index) {
      return lod.levels.push({
        object: object,
        distance: distances[index]
      });
    });
  }, []);
  useFrame(function (state) {
    var _lod$current;

    return (_lod$current = lod.current) == null ? void 0 : _lod$current.update(state.camera);
  });
  return /*#__PURE__*/React.createElement("lOD", _extends({
    ref: mergeRefs([lod, ref])
  }, props), children);
});
var Line = /*#__PURE__*/React.forwardRef(function Line(_ref, ref) {
  var points = _ref.points,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'black' : _ref$color,
      vertexColors = _ref.vertexColors,
      lineWidth = _ref.lineWidth,
      dashed = _ref.dashed,
      rest = _objectWithoutPropertiesLoose(_ref, ["points", "color", "vertexColors", "lineWidth", "dashed"]);

  var _useState = useState(function () {
    return new Line2();
  }),
      _useState2 = _slicedToArray(_useState, 1),
      line2 = _useState2[0];

  var _useState3 = useState(function () {
    return new LineGeometry();
  }),
      _useState4 = _slicedToArray(_useState3, 1),
      lineGeometry = _useState4[0];

  var _useState5 = useState(function () {
    return new LineMaterial();
  }),
      _useState6 = _slicedToArray(_useState5, 1),
      lineMaterial = _useState6[0];

  var _useState7 = useState(function () {
    return new Vector2(512, 512);
  }),
      _useState8 = _slicedToArray(_useState7, 1),
      resolution = _useState8[0];

  useEffect(function () {
    lineGeometry.setPositions(points.flat());
    if (vertexColors) lineGeometry.setColors(vertexColors.flat());
    line2.computeLineDistances();
  }, [points, vertexColors, line2, lineGeometry]);
  useLayoutEffect(function () {
    if (dashed) {
      lineMaterial.defines.USE_DASH = '';
    } else {
      // Setting lineMaterial.defines.USE_DASH to undefined is apparently not sufficient.
      delete lineMaterial.defines.USE_DASH;
    }

    lineMaterial.needsUpdate = true;
  }, [dashed, lineMaterial]);
  return /*#__PURE__*/React.createElement("primitive", _extends({
    dispose: undefined,
    object: line2,
    ref: ref
  }, rest), /*#__PURE__*/React.createElement("primitive", {
    dispose: undefined,
    object: lineGeometry,
    attach: "geometry"
  }), /*#__PURE__*/React.createElement("primitive", _extends({
    dispose: undefined,
    object: lineMaterial,
    attach: "material",
    color: color,
    vertexColors: Boolean(vertexColors),
    resolution: resolution,
    linewidth: lineWidth,
    dashed: dashed
  }, rest)));
});
var PositionalAudio = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var url = _ref.url,
      _ref$distance = _ref.distance,
      distance = _ref$distance === void 0 ? 1 : _ref$distance,
      _ref$loop = _ref.loop,
      loop = _ref$loop === void 0 ? true : _ref$loop,
      props = _objectWithoutPropertiesLoose(_ref, ["url", "distance", "loop"]);

  var sound = useRef();

  var _useThree = useThree(),
      camera = _useThree.camera;

  var _useState9 = useState(function () {
    return new AudioListener();
  }),
      _useState10 = _slicedToArray(_useState9, 1),
      listener = _useState10[0];

  var buffer = useLoader(AudioLoader, url);
  useEffect(function () {
    var _sound = sound.current;

    if (_sound) {
      _sound.setBuffer(buffer);

      _sound.setRefDistance(distance);

      _sound.setLoop(loop);

      _sound.play();
    }

    camera.add(listener);
    return function () {
      camera.remove(listener);

      if (_sound) {
        _sound.stop();

        _sound.disconnect();
      }
    };
  }, [buffer, camera, distance, listener, loop]);
  return /*#__PURE__*/React.createElement("positionalAudio", _extends({
    ref: mergeRefs([sound, ref]),
    args: [listener]
  }, props));
});
var Text = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$anchorX = _ref.anchorX,
      anchorX = _ref$anchorX === void 0 ? 'center' : _ref$anchorX,
      _ref$anchorY = _ref.anchorY,
      anchorY = _ref$anchorY === void 0 ? 'middle' : _ref$anchorY,
      children = _ref.children,
      onSync = _ref.onSync,
      props = _objectWithoutPropertiesLoose(_ref, ["anchorX", "anchorY", "children", "onSync"]);

  var _useThree2 = useThree(),
      invalidate = _useThree2.invalidate;

  var _useState11 = useState(function () {
    return new Text$1();
  }),
      _useState12 = _slicedToArray(_useState11, 1),
      troikaMesh = _useState12[0];

  var _useMemo = useMemo(function () {
    var n = [];
    var t = '';
    Children.forEach(children, function (child) {
      if (typeof child === 'string') {
        t += child;
      } else {
        n.push(child);
      }
    });
    return [n, t];
  }, [children]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      nodes = _useMemo2[0],
      text = _useMemo2[1];

  useLayoutEffect(function () {
    return void troikaMesh.sync(function () {
      invalidate();
      if (onSync) onSync(troikaMesh);
    });
  });
  return /*#__PURE__*/React.createElement("primitive", _extends({
    dispose: undefined,
    object: troikaMesh,
    ref: ref,
    text: text,
    anchorX: anchorX,
    anchorY: anchorY
  }, props), nodes);
});

function getTexture(texture, gen, isCubeMap) {
  if (isCubeMap) {
    gen.compileEquirectangularShader();
    return gen.fromCubemap(texture).texture;
  }

  return gen.fromEquirectangular(texture).texture;
}

function Environment(_ref3) {
  var _ref3$background = _ref3.background,
      background = _ref3$background === void 0 ? false : _ref3$background,
      _ref3$files = _ref3.files,
      files = _ref3$files === void 0 ? ['px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'] : _ref3$files,
      _ref3$path = _ref3.path,
      path = _ref3$path === void 0 ? '/' : _ref3$path;

  var _useThree3 = useThree(),
      gl = _useThree3.gl,
      scene = _useThree3.scene;

  var isCubeMap = Array.isArray(files);
  var loader = isCubeMap ? CubeTextureLoader : RGBELoader; // @ts-expect-error

  var loaderResult = useLoader(loader, isCubeMap ? [files] : files, function (loader) {
    return loader.setPath(path);
  });
  var map = isCubeMap ? loaderResult[0] : loaderResult;
  useEffect(function () {
    var gen = new PMREMGenerator(gl);
    var texture = getTexture(map, gen, isCubeMap);
    if (background) scene.background = texture;
    scene.environment = texture;
    map.dispose();
    gen.dispose();
    return function () {
      scene.environment = scene.background = null;
    };
  }, [gl, map, isCubeMap, background, scene]);
  return null;
}

extend({
  EffectComposer: EffectComposer,
  RenderPass: RenderPass,
  ShaderPass: ShaderPass
});

var isWebGL2Available = function isWebGL2Available() {
  try {
    var canvas = document.createElement('canvas');
    return !!(window.WebGL2RenderingContext && canvas.getContext('webgl2'));
  } catch (e) {
    return false;
  }
};

var Effects = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$multisamping = _ref.multisamping,
      multisamping = _ref$multisamping === void 0 ? 8 : _ref$multisamping,
      _ref$renderIndex = _ref.renderIndex,
      renderIndex = _ref$renderIndex === void 0 ? 1 : _ref$renderIndex,
      _ref$disableGamma = _ref.disableGamma,
      disableGamma = _ref$disableGamma === void 0 ? false : _ref$disableGamma,
      _ref$disableRenderPas = _ref.disableRenderPass,
      disableRenderPass = _ref$disableRenderPas === void 0 ? false : _ref$disableRenderPas,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "multisamping", "renderIndex", "disableGamma", "disableRenderPass"]);

  var composer = useRef();

  var _useThree4 = useThree(),
      scene = _useThree4.scene,
      camera = _useThree4.camera,
      gl = _useThree4.gl,
      size = _useThree4.size;

  var _useState13 = useState(function () {
    if (isWebGL2Available() && multisamping > 0) {
      var t = new WebGLMultisampleRenderTarget(size.width, size.height, {
        format: RGBAFormat,
        encoding: sRGBEncoding
      });
      t.samples = 8;
      return t;
    }
  }),
      _useState14 = _slicedToArray(_useState13, 1),
      target = _useState14[0];

  useEffect(function () {
    var _composer$current, _composer$current2;

    (_composer$current = composer.current) == null ? void 0 : _composer$current.setSize(size.width, size.height);
    (_composer$current2 = composer.current) == null ? void 0 : _composer$current2.setPixelRatio(gl.getPixelRatio());
  }, [gl, size]);
  useFrame(function () {
    var _composer$current3;

    return (_composer$current3 = composer.current) == null ? void 0 : _composer$current3.render();
  }, renderIndex);
  return /*#__PURE__*/React.createElement("effectComposer", _extends({
    ref: mergeRefs([ref, composer]),
    args: [gl, target]
  }, props), !disableRenderPass && /*#__PURE__*/React.createElement("renderPass", {
    attachArray: "passes",
    args: [scene, camera]
  }), !disableGamma && /*#__PURE__*/React.createElement("shaderPass", {
    attachArray: "passes",
    args: [GammaCorrectionShader]
  }), children);
});
var OrthographicCamera = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$makeDefault = _ref.makeDefault,
      makeDefault = _ref$makeDefault === void 0 ? false : _ref$makeDefault,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "makeDefault"]);

  var _useThree5 = useThree(),
      setDefaultCamera = _useThree5.setDefaultCamera,
      camera = _useThree5.camera,
      size = _useThree5.size;

  var cameraRef = useUpdate(function (cam) {
    return cam.updateProjectionMatrix();
  }, [size, props]);
  useLayoutEffect(function () {
    if (makeDefault && cameraRef.current) {
      var oldCam = camera;
      setDefaultCamera(cameraRef.current);
      return function () {
        return setDefaultCamera(oldCam);
      };
    }
  }, [camera, cameraRef, makeDefault, setDefaultCamera]);
  return /*#__PURE__*/React.createElement("orthographicCamera", _extends({
    left: size.width / -2,
    right: size.width / 2,
    top: size.height / 2,
    bottom: size.height / -2,
    ref: mergeRefs([cameraRef, ref])
  }, props), children);
});
var PerspectiveCamera = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$makeDefault2 = _ref.makeDefault,
      makeDefault = _ref$makeDefault2 === void 0 ? false : _ref$makeDefault2,
      props = _objectWithoutPropertiesLoose(_ref, ["makeDefault"]);

  var _useThree6 = useThree(),
      setDefaultCamera = _useThree6.setDefaultCamera,
      camera = _useThree6.camera,
      size = _useThree6.size;

  var cameraRef = useUpdate(function (cam) {
    cam.aspect = size.width / size.height;
    cam.updateProjectionMatrix();
  }, [size, props]);
  useLayoutEffect(function () {
    if (makeDefault && cameraRef.current) {
      var oldCam = camera;
      setDefaultCamera(cameraRef.current);
      return function () {
        return setDefaultCamera(oldCam);
      };
    }
  }, [camera, cameraRef, makeDefault, setDefaultCamera]);
  return /*#__PURE__*/React.createElement("perspectiveCamera", _extends({
    ref: mergeRefs([cameraRef, ref])
  }, props));
});

function call(ref, value) {
  if (typeof ref === 'function') ref(value);else if (ref != null) ref.current = value;
}

function useEffectfulState(fn) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var cb = arguments.length > 2 ? arguments[2] : undefined;

  var _useState15 = useState(),
      _useState16 = _slicedToArray(_useState15, 2),
      state = _useState16[0],
      set = _useState16[1];

  useLayoutEffect(function () {
    var value = fn();
    set(value);
    call(cb, value);
    return function () {
      return call(cb, null);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return state;
}

var DeviceOrientationControls = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useThree7 = useThree(),
      camera = _useThree7.camera,
      invalidate = _useThree7.invalidate;

  var controls = useEffectfulState(function () {
    return new DeviceOrientationControls$1(camera);
  }, [camera], ref);
  useEffect(function () {
    controls == null ? void 0 : controls.addEventListener == null ? void 0 : controls.addEventListener('change', invalidate);
    return function () {
      return controls == null ? void 0 : controls.removeEventListener == null ? void 0 : controls.removeEventListener('change', invalidate);
    };
  }, [controls, invalidate]);
  useFrame(function () {
    return controls == null ? void 0 : controls.update();
  });
  useEffect(function () {
    var current = controls;
    current == null ? void 0 : current.connect();
    return function () {
      return current == null ? void 0 : current.dispose();
    };
  }, [controls]);
  return controls ? /*#__PURE__*/React.createElement("primitive", _extends({
    dispose: undefined,
    object: controls
  }, props)) : null;
});
var FlyControls = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useThree8 = useThree(),
      camera = _useThree8.camera,
      gl = _useThree8.gl,
      invalidate = _useThree8.invalidate;

  var controls = useEffectfulState(function () {
    return new FlyControls$1(camera, gl.domElement);
  }, [camera, gl.domElement], ref);
  useEffect(function () {
    controls == null ? void 0 : controls.addEventListener == null ? void 0 : controls.addEventListener('change', invalidate);
    return function () {
      return controls == null ? void 0 : controls.removeEventListener == null ? void 0 : controls.removeEventListener('change', invalidate);
    };
  }, [controls, invalidate]);
  useFrame(function (_, delta) {
    return controls == null ? void 0 : controls.update(delta);
  });
  return controls ? /*#__PURE__*/React.createElement("primitive", _extends({
    dispose: undefined,
    object: controls
  }, props)) : null;
});
var MapControls = /*#__PURE__*/forwardRef(function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    enableDamping: true
  };
  var ref = arguments.length > 1 ? arguments[1] : undefined;

  var _useThree9 = useThree(),
      camera = _useThree9.camera,
      gl = _useThree9.gl,
      invalidate = _useThree9.invalidate;

  var controls = useEffectfulState(function () {
    return new MapControls$1(camera, gl.domElement);
  }, [camera, gl], ref);
  useFrame(function () {
    return controls == null ? void 0 : controls.update();
  });
  useEffect(function () {
    controls == null ? void 0 : controls.addEventListener == null ? void 0 : controls.addEventListener('change', invalidate);
    return function () {
      return controls == null ? void 0 : controls.removeEventListener == null ? void 0 : controls.removeEventListener('change', invalidate);
    };
  }, [controls, invalidate]);
  return controls ? /*#__PURE__*/React.createElement("primitive", _extends({
    dispose: undefined,
    object: controls,
    enableDamping: true
  }, props)) : null;
});
var OrbitControls = /*#__PURE__*/forwardRef(function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    enableDamping: true
  };
  var ref = arguments.length > 1 ? arguments[1] : undefined;

  var _useThree10 = useThree(),
      camera = _useThree10.camera,
      gl = _useThree10.gl,
      invalidate = _useThree10.invalidate;

  var controls = useEffectfulState(function () {
    return new OrbitControls$1(camera, gl.domElement);
  }, [camera, gl], ref);
  useFrame(function () {
    return controls == null ? void 0 : controls.update();
  });
  useEffect(function () {
    controls == null ? void 0 : controls.addEventListener == null ? void 0 : controls.addEventListener('change', invalidate);
    return function () {
      return controls == null ? void 0 : controls.removeEventListener == null ? void 0 : controls.removeEventListener('change', invalidate);
    };
  }, [controls, invalidate]);
  return controls ? /*#__PURE__*/React.createElement("primitive", _extends({
    dispose: undefined,
    object: controls,
    enableDamping: true
  }, props)) : null;
});
var TrackballControls = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useThree11 = useThree(),
      camera = _useThree11.camera,
      gl = _useThree11.gl,
      invalidate = _useThree11.invalidate;

  var controls = useEffectfulState(function () {
    return new TrackballControls$1(camera, gl.domElement);
  }, [camera, gl], ref);
  useFrame(function () {
    return controls == null ? void 0 : controls.update();
  });
  useEffect(function () {
    controls == null ? void 0 : controls.addEventListener == null ? void 0 : controls.addEventListener('change', invalidate);
    return function () {
      return controls == null ? void 0 : controls.removeEventListener == null ? void 0 : controls.removeEventListener('change', invalidate);
    };
  }, [controls, invalidate]);
  return controls ? /*#__PURE__*/React.createElement("primitive", _extends({
    dispose: undefined,
    object: controls
  }, props)) : null;
});
var TransformControls = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  var transformOnlyPropNames = ['enabled', 'axis', 'mode', 'translationSnap', 'rotationSnap', 'scaleSnap', 'space', 'size', 'dragging', 'showX', 'showY', 'showZ'];
  var transformProps = pick(props, transformOnlyPropNames);
  var objectProps = omit(props, transformOnlyPropNames);

  var _useThree12 = useThree(),
      camera = _useThree12.camera,
      gl = _useThree12.gl,
      invalidate = _useThree12.invalidate;

  var controls = useEffectfulState(function () {
    return new TransformControls$1(camera, gl.domElement);
  }, [camera, gl.domElement], ref);
  var group = useRef();
  useLayoutEffect(function () {
    return void (controls == null ? void 0 : controls.attach(group.current));
  }, [children, controls]);
  useEffect(function () {
    controls == null ? void 0 : controls.addEventListener == null ? void 0 : controls.addEventListener('change', invalidate);
    return function () {
      return controls == null ? void 0 : controls.removeEventListener == null ? void 0 : controls.removeEventListener('change', invalidate);
    };
  }, [controls, invalidate]);
  return controls ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("primitive", _extends({
    dispose: undefined,
    object: controls
  }, transformProps)), /*#__PURE__*/React.createElement("group", _extends({
    ref: group
  }, objectProps), children)) : null;
});
var PointerLockControls = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useThree13 = useThree(),
      camera = _useThree13.camera,
      gl = _useThree13.gl,
      invalidate = _useThree13.invalidate;

  var controls = useEffectfulState(function () {
    return new PointerLockControls$1(camera, gl.domElement);
  }, [camera, gl.domElement], ref);
  useEffect(function () {
    controls == null ? void 0 : controls.addEventListener == null ? void 0 : controls.addEventListener('change', invalidate);
    return function () {
      return controls == null ? void 0 : controls.removeEventListener == null ? void 0 : controls.removeEventListener('change', invalidate);
    };
  }, [controls, invalidate]);
  useEffect(function () {
    var handler = function handler() {
      return controls == null ? void 0 : controls.lock();
    };

    document.addEventListener('click', handler);
    return function () {
      return document.removeEventListener('click', handler);
    };
  }, [controls]);
  return controls ? /*#__PURE__*/React.createElement("primitive", _extends({
    dispose: undefined,
    object: controls
  }, props)) : null;
});
var useProgress = create$1(function (set) {
  DefaultLoadingManager.onStart = function (item, loaded, total) {
    return set({
      active: true,
      item: item,
      loaded: loaded,
      total: total,
      progress: loaded / total * 100
    });
  };

  DefaultLoadingManager.onLoad = function () {
    return set({
      active: false
    });
  };

  DefaultLoadingManager.onError = function (item) {
    return set(function (state) {
      return {
        errors: [].concat(_toConsumableArray(state.errors), [item])
      };
    });
  };

  DefaultLoadingManager.onProgress = function (item, loaded, total) {
    return set({
      item: item,
      loaded: loaded,
      total: total,
      progress: loaded / total * 100
    });
  };

  return {
    errors: [],
    active: false,
    progress: 0,
    item: '',
    loaded: 0,
    total: 0
  };
});
var styles = {
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#171717',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
  },
  inner: {
    width: 100,
    height: 3,
    background: '#272727',
    textAlign: 'center'
  },
  bar: {
    height: 3,
    width: '100%',
    background: 'white',
    transformOrigin: 'left center'
  },
  data: {
    display: 'inline-block',
    position: 'relative',
    fontVariantNumeric: 'tabular-nums',
    marginTop: '0.8em',
    color: '#f0f0f0',
    fontSize: '0.6em',
    fontFamily: "-apple-system, BlinkMacSystemFont, \"Inter\", \"Segoe UI\", \"Helvetica Neue\", Helvetica, Arial, Roboto, Ubuntu, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
    whiteSpace: 'nowrap'
  }
};

function Loader(_ref4) {
  var containerStyles = _ref4.containerStyles,
      innerStyles = _ref4.innerStyles,
      barStyles = _ref4.barStyles,
      dataStyles = _ref4.dataStyles,
      _ref4$dataInterpolati = _ref4.dataInterpolation,
      dataInterpolation = _ref4$dataInterpolati === void 0 ? function (p) {
    return "Loading " + p.toFixed(2) + "%";
  } : _ref4$dataInterpolati,
      _ref4$initialState = _ref4.initialState,
      initialState = _ref4$initialState === void 0 ? function (active) {
    return active;
  } : _ref4$initialState;

  var _useProgress = useProgress(),
      active = _useProgress.active,
      progress = _useProgress.progress;

  var transition = useTransition(initialState(active), {
    from: {
      opacity: 1,
      progress: 0
    },
    leave: {
      opacity: 0
    },
    update: {
      progress: progress / 100
    }
  });
  return transition(function (_ref5, active) {
    var progress = _ref5.progress,
        opacity = _ref5.opacity;
    return active && /*#__PURE__*/React.createElement(a.div, {
      style: _extends({}, styles.container, {
        opacity: opacity
      }, containerStyles)
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: _extends({}, styles.inner, innerStyles)
    }, /*#__PURE__*/React.createElement(a.div, {
      style: _extends({}, styles.bar, {
        scaleX: progress
      }, barStyles)
    }), /*#__PURE__*/React.createElement(a.span, {
      style: _extends({}, styles.data, dataStyles)
    }, progress.to(dataInterpolation)))));
  });
}

function useCubeTexture(files, _ref6) {
  var path = _ref6.path;

  // @ts-ignore
  var _useLoader = useLoader( // @ts-ignore
  CubeTextureLoader, [files], function (loader) {
    return loader.setPath(path);
  }),
      _useLoader2 = _slicedToArray(_useLoader, 1),
      cubeTexture = _useLoader2[0];

  return cubeTexture;
}

useCubeTexture.preload = function (files, _ref7) {
  var path = _ref7.path;
  return useLoader.preload( // @ts-ignore
  CubeTextureLoader, [files], function (loader) {
    return loader.setPath(path);
  });
};

function useFBX(path) {
  return useLoader(FBXLoader, path);
}

useFBX.preload = function (path) {
  return useLoader.preload(FBXLoader, path);
};

function draco() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'https://www.gstatic.com/draco/v1/decoders/';
  return function (loader) {
    var dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath(url);
    loader.setDRACOLoader(dracoLoader);
  };
}

function useGLTF(path) {
  var useDraco = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var gltf = useLoader(GLTFLoader, path, useDraco ? draco(typeof useDraco === 'string' ? useDraco : undefined) : undefined);
  return gltf;
}

useGLTF.preload = function (path) {
  var useDraco = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return useLoader.preload(GLTFLoader, path, useDraco ? draco(typeof useDraco === 'string' ? useDraco : undefined) : undefined);
};

function useTexture(url) {
  return useLoader(TextureLoader, url);
}

useTexture.preload = function (url) {
  return useLoader.preload(TextureLoader, url);
};

var v1 = new Vector3();
var v2 = new Vector3();
var v3 = new Vector3();

function calculatePosition(el, camera, size) {
  var objectPos = v1.setFromMatrixPosition(el.matrixWorld);
  objectPos.project(camera);
  var widthHalf = size.width / 2;
  var heightHalf = size.height / 2;
  return [objectPos.x * widthHalf + widthHalf, -(objectPos.y * heightHalf) + heightHalf];
}

function isObjectBehindCamera(el, camera) {
  var objectPos = v1.setFromMatrixPosition(el.matrixWorld);
  var cameraPos = v2.setFromMatrixPosition(camera.matrixWorld);
  var deltaCamObj = objectPos.sub(cameraPos);
  var camDir = camera.getWorldDirection(v3);
  return deltaCamObj.angleTo(camDir) > Math.PI / 2;
}

function objectScale(el, camera) {
  if (camera instanceof PerspectiveCamera$1) {
    var objectPos = v1.setFromMatrixPosition(el.matrixWorld);
    var cameraPos = v2.setFromMatrixPosition(camera.matrixWorld);
    var vFOV = camera.fov * Math.PI / 180;
    var dist = objectPos.distanceTo(cameraPos);
    return 1 / (2 * Math.tan(vFOV / 2) * dist);
  }

  if (camera instanceof OrthographicCamera$1) return camera.zoom;
  return 1;
}

function objectZIndex(el, camera, zIndexRange) {
  if (camera instanceof PerspectiveCamera$1 || camera instanceof OrthographicCamera$1) {
    var objectPos = v1.setFromMatrixPosition(el.matrixWorld);
    var cameraPos = v2.setFromMatrixPosition(camera.matrixWorld);
    var dist = objectPos.distanceTo(cameraPos);
    var A = (zIndexRange[1] - zIndexRange[0]) / (camera.far - camera.near);
    var B = zIndexRange[1] - A * camera.far;
    return Math.round(A * dist + B);
  }

  return undefined;
}

var Html = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _portal$current;

  var children = _ref.children,
      _ref$eps = _ref.eps,
      eps = _ref$eps === void 0 ? 0.001 : _ref$eps,
      style = _ref.style,
      className = _ref.className,
      prepend = _ref.prepend,
      center = _ref.center,
      fullscreen = _ref.fullscreen,
      portal = _ref.portal,
      scaleFactor = _ref.scaleFactor,
      _ref$zIndexRange = _ref.zIndexRange,
      zIndexRange = _ref$zIndexRange === void 0 ? [16777271, 0] : _ref$zIndexRange,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "eps", "style", "className", "prepend", "center", "fullscreen", "portal", "scaleFactor", "zIndexRange"]);

  var _useThree14 = useThree(),
      gl = _useThree14.gl,
      scene = _useThree14.scene,
      camera = _useThree14.camera,
      size = _useThree14.size;

  var _useState17 = useState(function () {
    return document.createElement('div');
  }),
      _useState18 = _slicedToArray(_useState17, 1),
      el = _useState18[0];

  var group = useRef(null);
  var old = useRef([0, 0]);
  var target = (_portal$current = portal == null ? void 0 : portal.current) != null ? _portal$current : gl.domElement.parentNode;
  useEffect(function () {
    if (group.current) {
      scene.updateMatrixWorld();
      var vec = calculatePosition(group.current, camera, size);
      el.style.cssText = "position:absolute;top:0;left:0;transform:translate3d(" + vec[0] + "px," + vec[1] + "px,0);transform-origin:0 0;";

      if (target) {
        if (prepend) target.prepend(el);else target.appendChild(el);
      }

      return function () {
        if (target) target.removeChild(el);
        ReactDOM.unmountComponentAtNode(el);
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [target]);
  var styles = useMemo(function () {
    return _extends({
      position: 'absolute',
      transform: center ? 'translate3d(-50%,-50%,0)' : 'none'
    }, fullscreen && {
      top: -size.height / 2,
      left: -size.width / 2,
      width: size.width,
      height: size.height
    }, style);
  }, [style, center, fullscreen, size]);
  useEffect(function () {
    return void ReactDOM.render( /*#__PURE__*/React.createElement("div", {
      ref: ref,
      style: styles,
      className: className,
      children: children
    }), el);
  });
  useFrame(function () {
    if (group.current) {
      camera.updateMatrixWorld();
      var vec = calculatePosition(group.current, camera, size);

      if (Math.abs(old.current[0] - vec[0]) > eps || Math.abs(old.current[1] - vec[1]) > eps) {
        el.style.display = !isObjectBehindCamera(group.current, camera) ? 'block' : 'none';
        var scale = scaleFactor === undefined ? 1 : objectScale(group.current, camera) * scaleFactor;
        el.style.transform = "translate3d(" + vec[0] + "px," + vec[1] + "px,0) scale(" + scale + ")";
        el.style.zIndex = "" + objectZIndex(group.current, camera, zIndexRange);
      }

      old.current = vec;
    }
  });
  return /*#__PURE__*/React.createElement("group", _extends({}, props, {
    ref: group
  }));
});
var HTML = /*#__PURE__*/React.forwardRef(function (props, ref) {
  useEffect(function () {
    return void console.warn('The <HTML> component was renamed to <Html>');
  }, []);
  return /*#__PURE__*/React.createElement(Html, _extends({}, props, {
    ref: ref
  }));
});

var _inverseMatrix = new Matrix4();

var _ray = new Ray();

var _sphere = new Sphere$1();

var _vA = new Vector3();

function meshBounds(raycaster, intersects) {
  var geometry = this.geometry;
  var material = this.material;
  var matrixWorld = this.matrixWorld;
  if (material === undefined) return; // Checking boundingSphere distance to ray

  if (geometry.boundingSphere === null) geometry.computeBoundingSphere();

  _sphere.copy(geometry.boundingSphere);

  _sphere.applyMatrix4(matrixWorld);

  if (raycaster.ray.intersectsSphere(_sphere) === false) return;

  _inverseMatrix.getInverse(matrixWorld);

  _ray.copy(raycaster.ray).applyMatrix4(_inverseMatrix); // Check boundingBox before continuing


  if (geometry.boundingBox !== null && _ray.intersectBox(geometry.boundingBox, _vA) === null) return;
  intersects.push({
    distance: _vA.distanceTo(raycaster.ray.origin),
    point: _vA.clone(),
    object: this
  });
}

var Reflector = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      color = _ref.color,
      textureWidth = _ref.textureWidth,
      textureHeight = _ref.textureHeight,
      clipBias = _ref.clipBias,
      shader = _ref.shader,
      encoding = _ref.encoding,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "color", "textureWidth", "textureHeight", "clipBias", "shader", "encoding"]);

  var reflector = useMemo(function () {
    return new Reflector$1(undefined, {
      color: color,
      textureWidth: textureWidth,
      textureHeight: textureHeight,
      clipBias: clipBias,
      shader: shader,
      encoding: encoding
    });
  }, [clipBias, color, encoding, shader, textureHeight, textureWidth]);
  return /*#__PURE__*/React.createElement("primitive", _extends({
    dispose: undefined,
    object: reflector,
    ref: ref
  }, props), React.Children.only(children));
});
var Shadow = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$fog = _ref.fog,
      fog = _ref$fog === void 0 ? false : _ref$fog,
      _ref$colorStop = _ref.colorStop,
      colorStop = _ref$colorStop === void 0 ? 0.0 : _ref$colorStop,
      _ref$color2 = _ref.color,
      color = _ref$color2 === void 0 ? 'black' : _ref$color2,
      _ref$opacity = _ref.opacity,
      opacity = _ref$opacity === void 0 ? 0.5 : _ref$opacity,
      props = _objectWithoutPropertiesLoose(_ref, ["fog", "colorStop", "color", "opacity"]);

  var canvas = useMemo(function () {
    var canvas = document.createElement('canvas');
    canvas.width = 128;
    canvas.height = 128;
    var context = canvas.getContext('2d');
    var gradient = context.createRadialGradient(canvas.width / 2, canvas.height / 2, 0, canvas.width / 2, canvas.height / 2, canvas.width / 2);
    gradient.addColorStop(colorStop, new Color(color).getStyle());
    gradient.addColorStop(1, 'rgba(0,0,0,0)');
    context.fillStyle = gradient;
    context.fillRect(0, 0, canvas.width, canvas.height);
    return canvas;
  }, [color, colorStop]);
  return /*#__PURE__*/React.createElement("mesh", _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement("planeBufferGeometry", {
    attach: "geometry",
    args: [1, 1]
  }), /*#__PURE__*/React.createElement("meshBasicMaterial", {
    attach: "material",
    transparent: true,
    opacity: opacity,
    fog: fog
  }, /*#__PURE__*/React.createElement("canvasTexture", {
    attach: "map",
    args: [canvas]
  })));
});

function Stats(_ref8) {
  var _ref8$showPanel = _ref8.showPanel,
      showPanel = _ref8$showPanel === void 0 ? 0 : _ref8$showPanel,
      className = _ref8.className,
      parent = _ref8.parent;
  var stats = useEffectfulState(function () {
    return new StatsImpl();
  }, []);
  useEffect(function () {
    if (stats) {
      var node = parent && parent.current || document.body;
      stats.showPanel(showPanel);
      node == null ? void 0 : node.appendChild(stats.dom);
      if (className) stats.dom.classList.add(className);
      var begin = addEffect(function () {
        return stats.begin();
      });
      var end = addAfterEffect(function () {
        return stats.end();
      });
      return function () {
        node == null ? void 0 : node.removeChild(stats.dom);
        begin();
        end();
      };
    }
  }, [parent, stats, className, showPanel]);
  return null;
}

function useAspect(type, width, height) {
  var factor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  var _useThree15 = useThree(),
      v = _useThree15.viewport,
      aspect = _useThree15.aspect;

  var adaptedHeight = height * (aspect > width / height ? v.width / width : v.height / height);
  var adaptedWidth = width * (aspect > width / height ? v.width / width : v.height / height);
  return [adaptedWidth * factor, adaptedHeight * factor, 1];
}

function useCamera(camera, props) {
  var _useThree16 = useThree(),
      mouse = _useThree16.mouse;

  var _useState19 = useState(function () {
    var raycaster = new Raycaster();
    if (props) applyProps(raycaster, props, {});
    return function (_, intersects) {
      raycaster.setFromCamera(mouse, camera instanceof Camera ? camera : camera.current);
      var rc = this.constructor.prototype.raycast.bind(this);
      if (rc) rc(raycaster, intersects);
    };
  }),
      _useState20 = _slicedToArray(_useState19, 1),
      raycast = _useState20[0];

  return raycast;
}

function useDetectGPU(props) {
  var GPUTier = useMemo(function () {
    var GPUTier = getGPUTier(props);
    return {
      isDesktop: GPUTier.tier.indexOf('DESKTOP') > -1,
      isMobile: GPUTier.tier.indexOf('MOBILE') > -1,
      tier: GPUTier.tier.split('_').pop(),
      type: GPUTier.type
    };
  }, [props]);
  return GPUTier;
}

function useHelper(object3D, proto) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var helper = React.useRef();

  var _useThree17 = useThree(),
      scene = _useThree17.scene;

  useEffect(function () {
    if (proto && object3D.current) {
      helper.current = _construct(proto, [object3D.current].concat(args));

      if (helper.current) {
        scene.add(helper.current);
      }
    }

    return function () {
      if (helper.current) {
        scene.remove(helper.current);
      }
    };
  }, [scene, proto, object3D, args]);
  useFrame(function () {
    if (helper.current) {
      helper.current.update();
    }
  });
  return helper;
}
/* eslint-disable react-hooks/rules-of-hooks */


function useContextBridge() {
  for (var _len2 = arguments.length, contexts = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    contexts[_key2] = arguments[_key2];
  }

  var cRef = useRef([]);
  cRef.current = contexts.map(function (context) {
    return React.useContext(context);
  });
  return useMemo(function () {
    return function (_ref9) {
      var children = _ref9.children;
      return contexts.reduceRight(function (acc, Context, i) {
        return /*#__PURE__*/React.createElement(Context.Provider, {
          value: cRef.current[i],
          children: acc
        });
      }, children);
    };
  }, []);
}

function useSimplification(simplePercent) {
  var ref = useRef();
  var original = useRef();
  var modifier = useRef();
  useEffect(function () {
    if (!original.current) {
      original.current = ref.current.geometry.clone();
      modifier.current = new SimplifyModifier();
    }
  }, []);
  useEffect(function () {
    if (original.current && ref.current) {
      var geometry = new BufferGeometry();

      if (original.current instanceof BufferGeometry) {
        geometry = original.current.clone();
      } else {
        geometry = geometry.fromGeometry(original.current);
      }

      var count = Math.floor(geometry.attributes.position.count * simplePercent); // number of vertices to remove

      ref.current.geometry = modifier.current.modify(geometry, count);
    }
  }, [simplePercent]);
  return ref;
}

function useSubdivision(subdivisions) {
  var ref = useRef();
  var original = useRef();
  var modifier = useRef();
  useEffect(function () {
    if (!original.current) {
      original.current = ref.current.geometry.clone();
      modifier.current = new SubdivisionModifier(parseInt(subdivisions));
    }
  }, [subdivisions]);
  useEffect(function () {
    modifier.current.subdivisions = subdivisions;
  }, [subdivisions]);
  useEffect(function () {
    if (original.current && ref.current) {
      var bufferGeometry = new BufferGeometry();
      var subdivided = bufferGeometry.fromGeometry(modifier.current.modify(original.current));
      ref.current.geometry = subdivided;
    }
  }, [subdivisions]);
  return ref;
}

function useTessellation() {
  var passes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
  var maxEdgeLength = arguments.length > 1 ? arguments[1] : undefined;
  var ref = useRef();
  var original = useRef();
  var modifier = useRef();
  useEffect(function () {
    if (!original.current) {
      original.current = ref.current.geometry.clone();
      modifier.current = new TessellateModifier(parseInt(maxEdgeLength));
    }
  }, [maxEdgeLength]);
  useEffect(function () {
    modifier.current.maxEdgeLength = maxEdgeLength;
  }, [maxEdgeLength]);
  useEffect(function () {
    if (original.current && ref.current) {
      var geometry = new Geometry();

      if (original.current instanceof BufferGeometry) {
        geometry.fromBufferGeometry(original.current);
      } else {
        geometry = original.current.clone();
      }

      var bufferGeometry = new BufferGeometry();

      for (var i = 0; i < passes; i++) {
        modifier.current.modify(geometry);
      }

      var tessellated = bufferGeometry.fromGeometry(geometry);
      ref.current.geometry = tessellated;
    }
  }, [maxEdgeLength, passes]);
  return ref;
}

var distort = "#define GLSLIFY 1\nvec3 mod289(vec3 x){return x-floor(x*(1.0/289.0))*289.0;}vec4 mod289(vec4 x){return x-floor(x*(1.0/289.0))*289.0;}vec4 permute(vec4 x){return mod289(((x*34.0)+1.0)*x);}vec4 taylorInvSqrt(vec4 r){return 1.79284291400159-0.85373472095314*r;}float snoise(vec3 v){const vec2 C=vec2(1.0/6.0,1.0/3.0);const vec4 D=vec4(0.0,0.5,1.0,2.0);vec3 i=floor(v+dot(v,C.yyy));vec3 x0=v-i+dot(i,C.xxx);vec3 g=step(x0.yzx,x0.xyz);vec3 l=1.0-g;vec3 i1=min(g.xyz,l.zxy);vec3 i2=max(g.xyz,l.zxy);vec3 x1=x0-i1+C.xxx;vec3 x2=x0-i2+C.yyy;vec3 x3=x0-D.yyy;i=mod289(i);vec4 p=permute(permute(permute(i.z+vec4(0.0,i1.z,i2.z,1.0))+i.y+vec4(0.0,i1.y,i2.y,1.0))+i.x+vec4(0.0,i1.x,i2.x,1.0));float n_=0.142857142857;vec3 ns=n_*D.wyz-D.xzx;vec4 j=p-49.0*floor(p*ns.z*ns.z);vec4 x_=floor(j*ns.z);vec4 y_=floor(j-7.0*x_);vec4 x=x_*ns.x+ns.yyyy;vec4 y=y_*ns.x+ns.yyyy;vec4 h=1.0-abs(x)-abs(y);vec4 b0=vec4(x.xy,y.xy);vec4 b1=vec4(x.zw,y.zw);vec4 s0=floor(b0)*2.0+1.0;vec4 s1=floor(b1)*2.0+1.0;vec4 sh=-step(h,vec4(0.0));vec4 a0=b0.xzyw+s0.xzyw*sh.xxyy;vec4 a1=b1.xzyw+s1.xzyw*sh.zzww;vec3 p0=vec3(a0.xy,h.x);vec3 p1=vec3(a0.zw,h.y);vec3 p2=vec3(a1.xy,h.z);vec3 p3=vec3(a1.zw,h.w);vec4 norm=taylorInvSqrt(vec4(dot(p0,p0),dot(p1,p1),dot(p2,p2),dot(p3,p3)));p0*=norm.x;p1*=norm.y;p2*=norm.z;p3*=norm.w;vec4 m=max(0.6-vec4(dot(x0,x0),dot(x1,x1),dot(x2,x2),dot(x3,x3)),0.0);m=m*m;return 42.0*dot(m*m,vec4(dot(p0,x0),dot(p1,x1),dot(p2,x2),dot(p3,x3)));}"; // eslint-disable-line

var DistortMaterialImpl = /*#__PURE__*/function (_MeshPhysicalMaterial) {
  _inherits(DistortMaterialImpl, _MeshPhysicalMaterial);

  var _super = _createSuper(DistortMaterialImpl);

  function DistortMaterialImpl() {
    var _this;

    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, DistortMaterialImpl);

    _this = _super.call(this, parameters);

    _defineProperty(_assertThisInitialized(_this), "_time", void 0);

    _defineProperty(_assertThisInitialized(_this), "_distort", void 0);

    _defineProperty(_assertThisInitialized(_this), "_radius", void 0);

    _this.setValues(parameters);

    _this._time = {
      value: 0
    };
    _this._distort = {
      value: 0.4
    };
    _this._radius = {
      value: 1
    };
    return _this;
  }

  _createClass(DistortMaterialImpl, [{
    key: "onBeforeCompile",
    value: function onBeforeCompile(shader) {
      shader.uniforms.time = this._time;
      shader.uniforms.radius = this._radius;
      shader.uniforms.distort = this._distort;
      shader.vertexShader = "\n      uniform float time;\n      uniform float radius;\n      uniform float distort;\n      " + distort + "\n      " + shader.vertexShader + "\n    ";
      shader.vertexShader = shader.vertexShader.replace('#include <begin_vertex>', "\n        float updateTime = time / 50.0;\n        float noise = snoise(vec3(position / 2.0 + updateTime * 5.0));\n        vec3 transformed = vec3(position * (noise * pow(distort, 2.0) + radius));\n        ");
    }
  }, {
    key: "time",
    get: function get() {
      return this._time.value;
    },
    set: function set(v) {
      this._time.value = v;
    }
  }, {
    key: "distort",
    get: function get() {
      return this._distort.value;
    },
    set: function set(v) {
      this._distort.value = v;
    }
  }, {
    key: "radius",
    get: function get() {
      return this._radius.value;
    },
    set: function set(v) {
      this._radius.value = v;
    }
  }]);

  return DistortMaterialImpl;
}(MeshPhysicalMaterial);

var MeshDistortMaterial = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$speed = _ref.speed,
      speed = _ref$speed === void 0 ? 1 : _ref$speed,
      props = _objectWithoutPropertiesLoose(_ref, ["speed"]);

  var _useState21 = useState(function () {
    return new DistortMaterialImpl();
  }),
      _useState22 = _slicedToArray(_useState21, 1),
      material = _useState22[0];

  useFrame(function (state) {
    return material && (material.time = state.clock.getElapsedTime() * speed);
  });
  return /*#__PURE__*/React.createElement("primitive", _extends({
    dispose: undefined,
    object: material,
    ref: ref,
    attach: "material"
  }, props));
});

var WobbleMaterialImpl = /*#__PURE__*/function (_MeshStandardMaterial) {
  _inherits(WobbleMaterialImpl, _MeshStandardMaterial);

  var _super2 = _createSuper(WobbleMaterialImpl);

  function WobbleMaterialImpl() {
    var _this2;

    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, WobbleMaterialImpl);

    _this2 = _super2.call(this, parameters);

    _defineProperty(_assertThisInitialized(_this2), "_time", void 0);

    _defineProperty(_assertThisInitialized(_this2), "_factor", void 0);

    _this2.setValues(parameters);

    _this2._time = {
      value: 0
    };
    _this2._factor = {
      value: 1
    };
    return _this2;
  }

  _createClass(WobbleMaterialImpl, [{
    key: "onBeforeCompile",
    value: function onBeforeCompile(shader) {
      shader.uniforms.time = this._time;
      shader.uniforms.factor = this._factor;
      shader.vertexShader = "\n      uniform float time;\n      uniform float factor;\n      " + shader.vertexShader + "\n    ";
      shader.vertexShader = shader.vertexShader.replace('#include <begin_vertex>', "float theta = sin( time + position.y ) / 2.0 * factor;\n        float c = cos( theta );\n        float s = sin( theta );\n        mat3 m = mat3( c, 0, s, 0, 1, 0, -s, 0, c );\n        vec3 transformed = vec3( position ) * m;\n        vNormal = vNormal * m;");
    }
  }, {
    key: "time",
    get: function get() {
      return this._time.value;
    },
    set: function set(v) {
      this._time.value = v;
    }
  }, {
    key: "factor",
    get: function get() {
      return this._factor.value;
    },
    set: function set(v) {
      this._factor.value = v;
    }
  }]);

  return WobbleMaterialImpl;
}(MeshStandardMaterial);

var MeshWobbleMaterial = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$speed2 = _ref.speed,
      speed = _ref$speed2 === void 0 ? 1 : _ref$speed2,
      props = _objectWithoutPropertiesLoose(_ref, ["speed"]);

  var _useState23 = useState(function () {
    return new WobbleMaterialImpl();
  }),
      _useState24 = _slicedToArray(_useState23, 1),
      material = _useState24[0];

  useFrame(function (state) {
    return material && (material.time = state.clock.getElapsedTime() * speed);
  });
  return /*#__PURE__*/React.createElement("primitive", _extends({
    dispose: undefined,
    object: material,
    ref: ref,
    attach: "material"
  }, props));
});

function shaderMaterial(uniforms, vertexShader, fragmentShader, onInit) {
  return /*#__PURE__*/function (_ShaderMaterial) {
    _inherits(_class, _ShaderMaterial);

    var _super3 = _createSuper(_class);

    function _class() {
      var _this3;

      _classCallCheck(this, _class);

      var entries = Object.entries(uniforms); // Create unforms and shaders

      _this3 = _super3.call(this, {
        uniforms: entries.reduce(function (acc, _ref10) {
          var _ref11 = _slicedToArray(_ref10, 2),
              name = _ref11[0],
              value = _ref11[1];

          return _extends({}, acc, _defineProperty2({}, name, {
            value: value
          }));
        }, {}),
        vertexShader: vertexShader,
        fragmentShader: fragmentShader
      }); // Create getter/setters

      entries.forEach(function (_ref12) {
        var _ref13 = _slicedToArray(_ref12, 1),
            name = _ref13[0];

        return Object.defineProperty(_assertThisInitialized(_this3), name, {
          get: function get() {
            return _this3.uniforms[name].value;
          },
          set: function set(v) {
            return _this3.uniforms[name].value = v;
          }
        });
      });
      if (onInit) onInit(_assertThisInitialized(_this3));
      return _this3;
    }

    return _class;
  }(ShaderMaterial);
}

function calcPosFromAngles(inclination, azimuth) {
  var vector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Vector3();
  var theta = Math.PI * (inclination - 0.5);
  var phi = 2 * Math.PI * (azimuth - 0.5);
  vector.x = Math.cos(phi);
  vector.y = Math.sin(theta);
  vector.z = Math.sin(phi);
  return vector;
}

var Sky = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$inclination = _ref.inclination,
      inclination = _ref$inclination === void 0 ? 0 : _ref$inclination,
      _ref$azimuth = _ref.azimuth,
      azimuth = _ref$azimuth === void 0 ? 0.25 : _ref$azimuth,
      _ref$distance2 = _ref.distance,
      distance = _ref$distance2 === void 0 ? 100 : _ref$distance2,
      _ref$mieCoefficient = _ref.mieCoefficient,
      mieCoefficient = _ref$mieCoefficient === void 0 ? 0.005 : _ref$mieCoefficient,
      _ref$mieDirectionalG = _ref.mieDirectionalG,
      mieDirectionalG = _ref$mieDirectionalG === void 0 ? 0.8 : _ref$mieDirectionalG,
      _ref$rayleigh = _ref.rayleigh,
      rayleigh = _ref$rayleigh === void 0 ? 1 : _ref$rayleigh,
      _ref$turbidity = _ref.turbidity,
      turbidity = _ref$turbidity === void 0 ? 2 : _ref$turbidity,
      _ref$sunPosition = _ref.sunPosition,
      sunPosition = _ref$sunPosition === void 0 ? calcPosFromAngles(inclination, azimuth) : _ref$sunPosition,
      props = _objectWithoutPropertiesLoose(_ref, ["inclination", "azimuth", "distance", "mieCoefficient", "mieDirectionalG", "rayleigh", "turbidity", "sunPosition"]);

  var scale = useMemo(function () {
    return new Vector3().setScalar(distance);
  }, [distance]);

  var _useState25 = useState(function () {
    return new Sky$1();
  }),
      _useState26 = _slicedToArray(_useState25, 1),
      sky = _useState26[0];

  return /*#__PURE__*/React.createElement("primitive", _extends({
    dispose: undefined,
    object: sky,
    ref: ref,
    "material-uniforms-mieCoefficient-value": mieCoefficient,
    "material-uniforms-mieDirectionalG-value": mieDirectionalG,
    "material-uniforms-rayleigh-value": rayleigh,
    "material-uniforms-sunPosition-value": sunPosition,
    "material-uniforms-turbidity-value": turbidity,
    scale: scale
  }, props));
});

var pcss = function pcss() {
  var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref14$frustrum = _ref14.frustrum,
      frustrum = _ref14$frustrum === void 0 ? 3.75 : _ref14$frustrum,
      _ref14$size = _ref14.size,
      size = _ref14$size === void 0 ? 0.005 : _ref14$size,
      _ref14$near = _ref14.near,
      near = _ref14$near === void 0 ? 9.5 : _ref14$near,
      _ref14$samples = _ref14.samples,
      samples = _ref14$samples === void 0 ? 17 : _ref14$samples,
      _ref14$rings = _ref14.rings,
      rings = _ref14$rings === void 0 ? 11 : _ref14$rings;

  return "#define LIGHT_WORLD_SIZE " + size + "\n#define LIGHT_FRUSTUM_WIDTH " + frustrum + "\n#define LIGHT_SIZE_UV (LIGHT_WORLD_SIZE / LIGHT_FRUSTUM_WIDTH)\n#define NEAR_PLANE " + near + "\n\n#define NUM_SAMPLES " + samples + "\n#define NUM_RINGS " + rings + "\n#define BLOCKER_SEARCH_NUM_SAMPLES NUM_SAMPLES\n#define PCF_NUM_SAMPLES NUM_SAMPLES\n\nvec2 poissonDisk[NUM_SAMPLES];\n\nvoid initPoissonSamples(const in vec2 randomSeed) {\n\tfloat ANGLE_STEP = PI2 * float(NUM_RINGS) / float(NUM_SAMPLES);\n\tfloat INV_NUM_SAMPLES = 1.0 / float(NUM_SAMPLES);\n\tfloat angle = rand(randomSeed) * PI2;\n\tfloat radius = INV_NUM_SAMPLES;\n\tfloat radiusStep = radius;\n\tfor (int i = 0; i < NUM_SAMPLES; i++) {\n\t\tpoissonDisk[i] = vec2(cos(angle), sin(angle)) * pow(radius, 0.75);\n\t\tradius += radiusStep;\n\t\tangle += ANGLE_STEP;\n\t}\n}\n\nfloat penumbraSize(const in float zReceiver, const in float zBlocker) { // Parallel plane estimation\n\treturn (zReceiver - zBlocker) / zBlocker;\n}\n\nfloat findBlocker(sampler2D shadowMap, const in vec2 uv, const in float zReceiver) {\n\tfloat searchRadius = LIGHT_SIZE_UV * (zReceiver - NEAR_PLANE) / zReceiver;\n\tfloat blockerDepthSum = 0.0;\n\tint numBlockers = 0;\n\tfor (int i = 0; i < BLOCKER_SEARCH_NUM_SAMPLES; i++) {\n\t\tfloat shadowMapDepth = unpackRGBAToDepth(texture2D(shadowMap, uv + poissonDisk[i] * searchRadius));\n\t\tif (shadowMapDepth < zReceiver) {\n\t\t\tblockerDepthSum += shadowMapDepth;\n\t\t\tnumBlockers++;\n\t\t}\n\t}\n\tif (numBlockers == 0) return -1.0;\n\treturn blockerDepthSum / float(numBlockers);\n}\n\nfloat PCF_Filter(sampler2D shadowMap, vec2 uv, float zReceiver, float filterRadius) {\n\tfloat sum = 0.0;\n\tfor (int i = 0; i < PCF_NUM_SAMPLES; i++) {\n\t\tfloat depth = unpackRGBAToDepth(texture2D(shadowMap, uv + poissonDisk[ i ] * filterRadius));\n\t\tif (zReceiver <= depth) sum += 1.0;\n\t}\n\tfor (int i = 0; i < PCF_NUM_SAMPLES; i++) {\n\t\tfloat depth = unpackRGBAToDepth(texture2D(shadowMap, uv + -poissonDisk[ i ].yx * filterRadius));\n\t\tif (zReceiver <= depth) sum += 1.0;\n\t}\n\treturn sum / (2.0 * float(PCF_NUM_SAMPLES));\n}\n\nfloat PCSS(sampler2D shadowMap, vec4 coords) {\n\tvec2 uv = coords.xy;\n\tfloat zReceiver = coords.z; // Assumed to be eye-space z in this code\n\tinitPoissonSamples(uv);\n\tfloat avgBlockerDepth = findBlocker(shadowMap, uv, zReceiver);\n\tif (avgBlockerDepth == -1.0) return 1.0;\n\tfloat penumbraRatio = penumbraSize(zReceiver, avgBlockerDepth);\n\tfloat filterRadius = penumbraRatio * LIGHT_SIZE_UV * NEAR_PLANE / zReceiver;\n\treturn PCF_Filter(shadowMap, uv, zReceiver, filterRadius);\n}";
};

var deployed = false;

var softShadows = function softShadows(props) {
  // Avoid adding the effect twice, which may happen in HMR scenarios
  if (!deployed) {
    deployed = true;
    var shader = ShaderChunk.shadowmap_pars_fragment;
    shader = shader.replace('#ifdef USE_SHADOWMAP', '#ifdef USE_SHADOWMAP\n' + pcss(_extends({}, props)));
    shader = shader.replace('#if defined( SHADOWMAP_TYPE_PCF )', '\nreturn PCSS(shadowMap, shadowCoord);\n#if defined( SHADOWMAP_TYPE_PCF )');
    ShaderChunk.shadowmap_pars_fragment = shader;
  }
};

var StarfieldMaterial = /*#__PURE__*/function (_ShaderMaterial2) {
  _inherits(StarfieldMaterial, _ShaderMaterial2);

  var _super4 = _createSuper(StarfieldMaterial);

  function StarfieldMaterial() {
    _classCallCheck(this, StarfieldMaterial);

    return _super4.call(this, {
      uniforms: {
        time: {
          value: 0.0
        },
        fade: {
          value: 1.0
        }
      },
      vertexShader: "uniform float time;\n      attribute float size;\n      varying vec3 vColor;\n      void main() {\n        vColor = color;\n        vec4 mvPosition = modelViewMatrix * vec4(position, 0.5);\n        gl_PointSize = size * (30.0 / -mvPosition.z) * (3.0 + sin(mvPosition.x + 2.0 * time + 100.0));\n        gl_Position = projectionMatrix * mvPosition;\n      }",
      fragmentShader: "uniform sampler2D pointTexture;\n      uniform float fade;\n      varying vec3 vColor;\n      void main() {\n        float opacity = 1.0;\n        if (fade == 1.0) {\n          float d = distance(gl_PointCoord, vec2(0.5, 0.5));\n          opacity = 1.0 / (1.0 + exp(16.0 * (d - 0.25)));\n        }\n        gl_FragColor = vec4(vColor, opacity);\n      }"
    });
  }

  return StarfieldMaterial;
}(ShaderMaterial);

var genStar = function genStar(r) {
  return new Vector3().setFromSpherical(new Spherical(r, Math.acos(1 - Math.random() * 2), Math.random() * 2 * Math.PI));
};

var Stars = /*#__PURE__*/forwardRef(function (_ref15, ref) {
  var _ref15$radius = _ref15.radius,
      radius = _ref15$radius === void 0 ? 100 : _ref15$radius,
      _ref15$depth = _ref15.depth,
      depth = _ref15$depth === void 0 ? 50 : _ref15$depth,
      _ref15$count = _ref15.count,
      count = _ref15$count === void 0 ? 5000 : _ref15$count,
      _ref15$saturation = _ref15.saturation,
      saturation = _ref15$saturation === void 0 ? 0 : _ref15$saturation,
      _ref15$factor = _ref15.factor,
      factor = _ref15$factor === void 0 ? 4 : _ref15$factor,
      _ref15$fade = _ref15.fade,
      fade = _ref15$fade === void 0 ? false : _ref15$fade;
  var material = useRef();

  var _useMemo3 = useMemo(function () {
    var positions = [];
    var colors = [];
    var sizes = Array.from({
      length: count
    }, function () {
      return (0.5 + 0.5 * Math.random()) * factor;
    });
    var color = new Color();
    var r = radius + depth;
    var increment = depth / count;

    for (var i = 0; i < count; i++) {
      r -= increment * Math.random();
      positions.push.apply(positions, _toConsumableArray(genStar(r).toArray()));
      color.setHSL(i / count, saturation, 0.9);
      colors.push(color.r, color.g, color.b);
    }

    return [new Float32Array(positions), new Float32Array(colors), new Float32Array(sizes)];
  }, [count, depth, factor, radius, saturation]),
      _useMemo4 = _slicedToArray(_useMemo3, 3),
      position = _useMemo4[0],
      color = _useMemo4[1],
      size = _useMemo4[2];

  useFrame(function (state) {
    return material.current && (material.current.uniforms.time.value = state.clock.getElapsedTime());
  });

  var _useState27 = useState(function () {
    return new StarfieldMaterial();
  }),
      _useState28 = _slicedToArray(_useState27, 1),
      starfieldMaterial = _useState28[0];

  return /*#__PURE__*/React.createElement("points", {
    ref: ref
  }, /*#__PURE__*/React.createElement("bufferGeometry", {
    attach: "geometry"
  }, /*#__PURE__*/React.createElement("bufferAttribute", {
    attachObject: ['attributes', 'position'],
    args: [position, 3]
  }), /*#__PURE__*/React.createElement("bufferAttribute", {
    attachObject: ['attributes', 'color'],
    args: [color, 3]
  }), /*#__PURE__*/React.createElement("bufferAttribute", {
    attachObject: ['attributes', 'size'],
    args: [size, 1]
  })), /*#__PURE__*/React.createElement("primitive", {
    dispose: undefined,
    ref: material,
    object: starfieldMaterial,
    attach: "material",
    blending: AdditiveBlending,
    "uniforms-fade-value": fade,
    transparent: true,
    vertexColors: true
  }));
});
var ContactShadows = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$opacity2 = _ref.opacity,
      opacity = _ref$opacity2 === void 0 ? 1 : _ref$opacity2,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 1 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 1 : _ref$height,
      _ref$blur = _ref.blur,
      blur = _ref$blur === void 0 ? 1 : _ref$blur,
      _ref$far = _ref.far,
      far = _ref$far === void 0 ? 10 : _ref$far,
      _ref$resolution = _ref.resolution,
      resolution = _ref$resolution === void 0 ? 256 : _ref$resolution,
      props = _objectWithoutPropertiesLoose(_ref, ["opacity", "width", "height", "blur", "far", "resolution"]);

  var _useThree18 = useThree(),
      scene = _useThree18.scene,
      gl = _useThree18.gl;

  var shadowCamera = useRef();

  var _useMemo5 = useMemo(function () {
    var renderTarget = new WebGLRenderTarget(resolution, resolution);
    var renderTargetBlur = new WebGLRenderTarget(resolution, resolution);
    renderTargetBlur.texture.generateMipmaps = renderTarget.texture.generateMipmaps = false;
    var planeGeometry = new PlaneBufferGeometry(width, height).rotateX(Math.PI / 2);
    var blurPlane = new Mesh(planeGeometry);
    var depthMaterial = new MeshDepthMaterial();
    depthMaterial.depthTest = depthMaterial.depthWrite = false;

    depthMaterial.onBeforeCompile = function (shader) {
      return shader.fragmentShader = shader.fragmentShader.replace('1.0 - fragCoordZ ), opacity );', '0.0 ), ( 1.0 - fragCoordZ ) * 1.0 );');
    };

    var horizontalBlurMaterial = new ShaderMaterial(HorizontalBlurShader);
    var verticalBlurMaterial = new ShaderMaterial(VerticalBlurShader);
    verticalBlurMaterial.depthTest = horizontalBlurMaterial.depthTest = false;
    return [renderTarget, planeGeometry, depthMaterial, blurPlane, horizontalBlurMaterial, verticalBlurMaterial, renderTargetBlur];
  }, [resolution, width, height]),
      _useMemo6 = _slicedToArray(_useMemo5, 7),
      renderTarget = _useMemo6[0],
      planeGeometry = _useMemo6[1],
      depthMaterial = _useMemo6[2],
      blurPlane = _useMemo6[3],
      horizontalBlurMaterial = _useMemo6[4],
      verticalBlurMaterial = _useMemo6[5],
      renderTargetBlur = _useMemo6[6];

  useFrame(function () {
    if (shadowCamera.current) {
      var initialBackground = scene.background;
      scene.background = null;
      scene.overrideMaterial = depthMaterial;
      gl.setRenderTarget(renderTarget);
      gl.render(scene, shadowCamera.current);
      scene.overrideMaterial = null;
      blurPlane.material = horizontalBlurMaterial;
      blurPlane.material.uniforms.tDiffuse.value = renderTarget.texture;
      horizontalBlurMaterial.uniforms.h.value = blur / 256;
      gl.setRenderTarget(renderTargetBlur);
      gl.render(blurPlane, shadowCamera.current);
      blurPlane.material = verticalBlurMaterial;
      blurPlane.material.uniforms.tDiffuse.value = renderTargetBlur.texture;
      verticalBlurMaterial.uniforms.v.value = blur / 256;
      gl.setRenderTarget(renderTarget);
      gl.render(blurPlane, shadowCamera.current);
      gl.setRenderTarget(null);
      scene.background = initialBackground;
    }
  });
  return /*#__PURE__*/React.createElement("group", _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("mesh", {
    geometry: planeGeometry,
    scale: [1, -1, 1],
    rotation: [-Math.PI / 2, 0, 0]
  }, /*#__PURE__*/React.createElement("meshBasicMaterial", {
    map: renderTarget.texture,
    transparent: true,
    opacity: opacity
  })), /*#__PURE__*/React.createElement("orthographicCamera", {
    ref: shadowCamera,
    args: [-width / 2, width / 2, height / 2, -height / 2, 0, far]
  }));
});
var eps = 0.00001;

function createShape(width, height, radius0) {
  var shape = new Shape();
  var radius = radius0 - eps;
  shape.absarc(eps, eps, eps, -Math.PI / 2, -Math.PI, true);
  shape.absarc(eps, height - radius * 2, eps, Math.PI, Math.PI / 2, true);
  shape.absarc(width - radius * 2, height - radius * 2, eps, Math.PI / 2, 0, true);
  shape.absarc(width - radius * 2, eps, eps, 0, -Math.PI / 2, true);
  return shape;
}

var RoundedBox = /*#__PURE__*/forwardRef(function RoundedBox(_ref, ref) {
  var _ref$args = _ref.args;
  _ref$args = _ref$args === void 0 ? [] : _ref$args;

  var _ref$args2 = _slicedToArray(_ref$args, 3),
      _ref$args2$ = _ref$args2[0],
      width = _ref$args2$ === void 0 ? 1 : _ref$args2$,
      _ref$args2$2 = _ref$args2[1],
      height = _ref$args2$2 === void 0 ? 1 : _ref$args2$2,
      _ref$args2$3 = _ref$args2[2],
      depth = _ref$args2$3 === void 0 ? 1 : _ref$args2$3,
      _ref$radius = _ref.radius,
      radius = _ref$radius === void 0 ? 0.05 : _ref$radius,
      _ref$smoothness = _ref.smoothness,
      smoothness = _ref$smoothness === void 0 ? 4 : _ref$smoothness,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["args", "radius", "smoothness", "children"]);

  var shape = useMemo(function () {
    return createShape(width, height, radius);
  }, [width, height, radius]);
  var params = useMemo(function () {
    return {
      depth: depth - radius * 2,
      bevelEnabled: true,
      bevelSegments: smoothness * 2,
      steps: 1,
      bevelSize: radius - eps,
      bevelThickness: radius,
      curveSegments: smoothness
    };
  }, [depth, radius, smoothness]);
  var geomRef = useUpdate(function (geometry) {
    return void geometry.center();
  }, [shape, params]);
  return /*#__PURE__*/React.createElement("mesh", _extends({
    ref: ref
  }, rest), /*#__PURE__*/React.createElement("extrudeBufferGeometry", {
    attach: "geometry",
    ref: geomRef,
    args: [shape, params]
  }), children);
});
var matcapList = {
  "0": "0404E8_0404B5_0404CB_3333FC",
  "1": "045C5C_0DBDBD_049393_04A4A4",
  "2": "046363_0CC3C3_049B9B_04ACAC",
  "3": "0489C5_0DDDF9_04C3EE_04AFE1",
  "4": "04989A_0CE3E4_04D2D5_04C7C8",
  "5": "04C455_0EFABC_04F097_04E17A",
  "6": "04CC77_0CF7CA_04E9A7_04AB54",
  "7": "04E804_04B504_04CB04_33FC33",
  "8": "04E8E8_04B5B5_04CCCC_33FCFC",
  "9": "050505_747474_4C4C4C_333333",
  "10": "070B0C_B2C7CE_728FA3_5B748B",
  "11": "090909_9C9C9C_555555_7C7C7C",
  "12": "0A0A0A_A9A9A9_525252_747474",
  "13": "0C0CC3_04049F_040483_04045C",
  "14": "0C430C_257D25_439A43_3C683C",
  "15": "0D0DBD_040497_04047B_040455",
  "16": "0D0DE3_040486_0404AF_0404CF",
  "17": "0DBD0D_049704_047B04_045504",
  "18": "0F0F0F_4B4B4B_1C1C1C_2C2C2C",
  "19": "0F990F_047B04_044604_046704",
  "20": "15100F_241D1B_292424_2C2C27",
  "21": "161B1F_C7E0EC_90A5B3_7B8C9B",
  "22": "167E76_36D6D2_23B2AC_27C1BE",
  "23": "17395A_7EBCC7_4D8B9F_65A1B5",
  "24": "181F1F_475057_616566_525C62",
  "25": "191514_6D5145_4E3324_3B564D",
  "26": "1A2461_3D70DB_2C3C8F_2C6CAC",
  "27": "1B1B1B_515151_7E7E7E_6C6C6C",
  "28": "1B1B1B_999999_575757_747474",
  "29": "1B1C19_5F615D_4B4E4C_3F403D",
  "30": "1C1810_352F23_2B2C1C_2B2C24",
  "31": "1C70C6_09294C_0F3F73_52B3F6",
  "32": "1D2424_565F66_4E555A_646C6E",
  "33": "1D2A21_43443B_655B54_545C54",
  "34": "1D3FCC_051B5F_81A0F2_5579E9",
  "35": "221917_928380_5F504D_7C746C",
  "36": "232014_908B78_5E5743_747460",
  "37": "242733_333A4D_3E4554_3C3B43",
  "38": "245642_3D8168_3D6858_417364",
  "39": "253C3C_528181_406C6C_385F5F",
  "40": "254FB0_99AFF0_6587D8_1D3279",
  "41": "27222B_677491_484F6A_5D657A",
  "42": "281813_604233_4B3426_442B22",
  "43": "28292A_D3DAE5_A3ACB8_818183",
  "44": "291912_473531_3C2C25_3A2424",
  "45": "293534_B2BFC5_738289_8A9AA7",
  "46": "293D21_ABC692_73B255_667C5C",
  "47": "2A2A2A_B3B3B3_6D6D6D_848C8C",
  "48": "2A2A2A_DBDBDB_6A6A6A_949494",
  "49": "2A2D21_555742_898974_6C745B",
  "50": "2A4BA7_1B2D44_1F3768_233C81",
  "51": "2A6276_041218_739BA6_042941",
  "52": "2B2828_7B796F_534F4A_616464",
  "53": "2B2B22_3C3C30_464538_121210",
  "54": "2D2D2A_74716E_8F8C8C_92958E",
  "55": "2D2D2F_C6C2C5_727176_94949B",
  "56": "2D8753_5CD6A5_45BB82_4CC494",
  "57": "2E2E2D_7D7C76_A3A39F_949C94",
  "58": "2E763A_78A0B7_B3D1CF_14F209",
  "59": "2EAC9E_61EBE3_4DDDD1_43D1C6",
  "60": "2F2FAA_1E1E87_10104E_1C1C70",
  "61": "2F3747_6A7C9E_54637F_62748B",
  "62": "300706_888576_822821_876E79",
  "63": "302721_CAC1BB_7A706A_91959B",
  "64": "304FB1_69A1EF_5081DF_5C8CE6",
  "65": "312C34_A2AAB3_61656A_808494",
  "66": "312D20_80675C_8B8C8B_85848C",
  "67": "313131_BBBBBB_878787_A3A4A4",
  "68": "320455_720DBE_560496_47047B",
  "69": "32201D_613C3C_563533_8C655F",
  "70": "32302B_4C4842_121211_1C1C14",
  "71": "323C4D_B79039_7C6A44_605C48",
  "72": "326666_66CBC9_C0B8AE_52B3B4",
  "73": "331A0B_B17038_7D4E28_5B351A",
  "74": "336EB3_152578_A4C5E2_74AED9",
  "75": "34352A_718184_50605E_6E6761",
  "76": "346088_6ABED7_56A0C5_4E91B8",
  "77": "34A09C_6EE5E3_5CD7D3_4EC9C6",
  "78": "34AB94_36DFC1_19F9EB_6C6E62",
  "79": "353535_CFCFCF_828282_A4A4A4",
  "80": "36220C_C6C391_8C844A_8B7B4C",
  "81": "36312E_726461_59504D_645C5C",
  "82": "365123_C6E5A3_A8D18D_8EB16C",
  "83": "36C8FA_176ACB_24A7EF_1D93EC",
  "84": "37C337_279F27_186018_248824",
  "85": "385264_A1D3E2_86ADC1_6E94A8",
  "86": "385862_6D8B8D_647B80_1A2E2F",
  "87": "386169_A9CFDB_153C23_7CA3AC",
  "88": "38925D_142B23_1D4835_2A6449",
  "89": "392307_B3AE7D_6D5618_847C42",
  "90": "39433A_65866E_86BF8B_BFF8D8",
  "91": "394641_B1A67E_75BEBE_7D7256",
  "92": "3A2412_A78B5F_705434_836C47",
  "93": "3A3329_C9B090_928069_A9957A",
  "94": "3A3D37_7E7F75_BCBFB6_9C9C94",
  "95": "3B3B3B_C7C7C7_878787_A4A4A4",
  "96": "3B3C3F_DAD9D5_929290_ABACA8",
  "97": "3B4235_7B9395_5B716C_70847B",
  "98": "3B6E10_E3F2C3_88AC2E_99CE51",
  "99": "3D1F12_653821_070404_22130B",
  "100": "3E2335_D36A1B_8E4A2E_2842A5",
  "101": "3E3D39_D6CEAF_91BAC1_897966",
  "102": "3E3E36_72726D_63645D_0E0F0C",
  "103": "3E3E3E_AEAEAE_848484_777777",
  "104": "3E95CC_65D9F1_A2E2F6_679BD4",
  "105": "3F3A2F_91D0A5_7D876A_94977B",
  "106": "3F3D52_CCCED9_AFB0C6_8D8CAC",
  "107": "3F4441_D1D7D6_888F87_A2ADA1",
  "108": "403A34_B0936E_7F979C_7E6956",
  "109": "415325_83A24E_678239_748C3C",
  "110": "416BA7_A5B8D0_0D2549_65ABEB",
  "111": "422509_C89536_824512_0A0604",
  "112": "422A1E_716767_685D59_5E4F4A",
  "113": "424244_BDBBBE_8A898E_A3A4A9",
  "114": "425F84_1C2939_2A3F57_24344C",
  "115": "430404_BD9295_7E1E21_94544C",
  "116": "432322_5E3839_170C0B_543433",
  "117": "433D3F_A58D7D_786760_8C7C6D",
  "118": "434240_D3D3CF_898784_A4A49F",
  "119": "434343_9E9E9E_8C8C8C_848484",
  "120": "434C32_62704C_546244_2F3220",
  "121": "442C27_A79E90_847066_8D837C",
  "122": "447072_8ACACB_65A4A5_74B3B3",
  "123": "45432C_808361_B8C8BC_A5A27A",
  "124": "454447_908E9A_181716_7C7C7B",
  "125": "456A73_779B9E_173A46_154C5D",
  "126": "463F37_ACCFBB_818B78_91A494",
  "127": "464445_D2D0CB_919196_A8ADB0",
  "128": "464543_D1CFC1_8E8C83_A4AC9C",
  "129": "46804D_CBE9AC_90B57C_95D38F",
  "130": "468126_C1DDB5_8AC460_A1D07C",
  "131": "47392E_997E69_7C6553_8B745F",
  "132": "474444_7B7575_9E9899_8C8C8B",
  "133": "474643_696F7D_A9ABB8_8B8C93",
  "134": "474843_CECEC4_898883_A3A3A4",
  "135": "48270F_C4723B_9B5728_7B431B",
  "136": "482908_894E0D_FBDB52_CA7420",
  "137": "487FC9_A8E7F8_88CCF2_70AFDE",
  "138": "489B7A_A0E7D9_6DC5AC_87DAC7",
  "139": "48C381_226640_369F64_3CAC74",
  "140": "49200B_C6926C_9C642B_A45C26",
  "141": "495CA6_CCD2E6_A5B1D8_1E2852",
  "142": "495E48_0D100D_9D9C87_9ECC9C",
  "143": "496DBA_94C9F2_72A7E2_84B4EC",
  "144": "4A6442_D0AB75_81CD94_181B12",
  "145": "4B362C_715A4F_211913_644C44",
  "146": "4B4A3A_94A3A4_68766F_988475",
  "147": "4B5455_BBBFC4_97A0A6_838C90",
  "148": "4C240E_A5613B_895134_734C44",
  "149": "4C342A_7B584B_271912_6B4C44",
  "150": "4C462E_6D876C_9AAC8F_9AABA6",
  "151": "4C4C4C_D2D2D2_8F8F8F_ACACAC",
  "152": "4D595E_858D87_596F84_748480",
  "153": "4E4C42_B8C4C5_898E89_A3ACA4",
  "154": "4E4D40_979786_AEAEA1_878678",
  "155": "4E5150_9FA3A3_848C8A_82848C",
  "156": "4F251B_381710_43241B_602F23",
  "157": "4F439F_A28BE5_8570D6_7765C9",
  "158": "4F4742_B7B1AA_847E79_969294",
  "159": "4F4C45_A7AEAA_7A8575_9D97A2",
  "160": "4F4F4F_9C9C9C_121212_7C7C7C",
  "161": "4F4F4F_A1A1A1_8C8C8C_848484",
  "162": "4F5246_8C8D84_7B7C74_131611",
  "163": "4FE34F_2BB02B_3CD03C_1C861C",
  "164": "50332C_D98D79_955F52_AA7C6C",
  "165": "503522_C38254_9F6B45_845838",
  "166": "504D3C_979C9D_81837D_9C998A",
  "167": "513A11_CDBEB5_C8811C_9A733F",
  "168": "51462B_DFCA7E_948050_A49874",
  "169": "515151_DCDCDC_B7B7B7_9B9B9B",
  "170": "515341_9A9C86_16180D_838474",
  "171": "517919_659623_34460C_3E5813",
  "172": "519C8D_83DAC7_9DEDE0_2B5B4C",
  "173": "522221_91343B_7F6F6B_744960",
  "174": "522A1A_94543A_C3896F_AB7D66",
  "175": "525050_D4D3D3_959393_ACACAC",
  "176": "533B33_AF9998_866965_9C7E7B",
  "177": "535A2F_CDCA91_91915B_A4AC6F",
  "178": "535F6B_A6BDC8_8FA3B4_7F91A2",
  "179": "537387_75BBB9_152E5B_0E85E8",
  "180": "54584E_B1BAC5_818B91_A7ACA3",
  "181": "545B4D_D8DDC8_A0A792_B2C1A3",
  "182": "54C104_BBFA0F_97EF04_7AE104",
  "183": "55382F_78554E_271A16_6C4C44",
  "184": "555555_C8C8C8_8B8B8B_A4A4A4",
  "185": "556F42_112817_81927F_223E24",
  "186": "55C404_BCFA0E_97F004_7AE104",
  "187": "562D2A_2E1615_7E4945_703C3C",
  "188": "56352F_1E110F_311C19_3C231C",
  "189": "57553F_C6C3AF_8C8768_868C8C",
  "190": "57583E_969788_292920_848474",
  "191": "579241_B5D25D_0E1D2D_97C284",
  "192": "582410_83381A_1F0C04_30140A",
  "193": "583629_2E1810_765648_3C1C14",
  "194": "584F3A_BEC3BD_C5A57D_A39073",
  "195": "586A51_CCD5AA_8C9675_8DBBB7",
  "196": "593E2C_E5D8A9_BC9F79_9F8A68",
  "197": "595356_CDBFC6_AA9DA3_BBB3BC",
  "198": "59554F_171716_847C74_2C2C24",
  "199": "596773_B3C6CE_98AFB9_879AA8",
  "200": "597C3F_254319_6C9668_7C9B53",
  "201": "5A492B_DEC583_987D4D_AC9C74",
  "202": "5A643B_454D2C_393F25_202315",
  "203": "5B4CBC_B59AF2_9B84EB_8F78E4",
  "204": "5B5428_C5A052_A28B46_ADA752",
  "205": "5B574E_586967_807C6F_6A746C",
  "206": "5C045C_BD0DBD_930493_A404A4",
  "207": "5C2E0C_C36924_9F4F14_834114",
  "208": "5C4E41_CCCDD6_9B979B_B1AFB0",
  "209": "5C5743_262418_393727_342C20",
  "210": "5C5C04_BDBD0D_939304_A4A404",
  "211": "5C5C5C_A2A2A2_8C8C8C_848484",
  "212": "5D5854_1A1714_373330_2C2424",
  "213": "5D5D5D_CDCDCD_232323_ACACAC",
  "214": "5D5E5A_A1A29B_2A2927_8B948C",
  "215": "5E423A_8C6E69_382416_745D64",
  "216": "5E5049_CDC2BE_9C8E88_B7ACA4",
  "217": "5E5855_C6C4CD_C89B67_8F8E98",
  "218": "5E5F62_A7B2BE_211C17_939CA3",
  "219": "5ECBA4_BCFAE7_92EED0_A1F4DC",
  "220": "5F1827_9B4A60_1F0404_340406",
  "221": "5F4C4B_A07C7D_A8AFBF_868185",
  "222": "5F4F50_A18E8E_8C7C7B_211A1A",
  "223": "5F5F5F_BDBDBD_A4A4A4_9C9C9C",
  "224": "604A30_DC9065_212C14_AC9C92",
  "225": "60534A_211813_9B948E_8E837D",
  "226": "605352_E9CCC5_C7A8A3_A89291",
  "227": "606857_9BA894_8C9C83_8C9483",
  "228": "613F04_D68C04_A45F04_1F0F04",
  "229": "61583E_252314_928972_342C1C",
  "230": "617586_23304C_1B1E30_4988CF",
  "231": "622F19_885934_9A7748_94603A",
  "232": "623622_A1756F_986353_89645B",
  "233": "624541_FCD0C6_E4A19A_FCBCB4",
  "234": "626262_9E9E9E_848484_262626",
  "235": "626262_A8A8A8_949494_1F1F1F",
  "236": "626A57_3B3F33_7D8973_444C3C",
  "237": "626D5C_B8C2BB_1B230F_A4ACA3",
  "238": "627D72_A6CAAA_202C28_B4D4B4",
  "239": "630463_C30CC3_9B049B_AC04AC",
  "240": "63533B_AA9472_1C1108_9B8C68",
  "241": "63584B_E6E0D6_A8A092_BFB6A8",
  "242": "635D52_A9BCC0_B1AEA0_819598",
  "243": "636363_AAAAAA_949494_252525",
  "244": "636D6C_D4E7ED_ABBCC4_9BA4A8",
  "245": "637598_B7C4D3_22293A_9BACBF",
  "246": "64554D_D1C9C1_ABADA0_0E0C0A",
  "247": "64686F_BDC0C4_161718_A4A7AB",
  "248": "647171_1F3349_2A475C_87A5AD",
  "249": "647686_23292E_333C44_404B55",
  "250": "656662_9B9B99_393B31_8B8C8C",
  "251": "657274_2A2F30_A0A7B0_363C44",
  "252": "65A0BA_C3E4F1_A7D5E6_97CADF",
  "253": "65A0C7_C3E4F8_A7D5EF_97CAE9",
  "254": "660505_F2B090_DD4D37_AA1914",
  "255": "66605E_939198_2E261F_3C332A",
  "256": "666864_B3B4AB_2F2F2C_9CA49B",
  "257": "673B2A_99735C_99593A_3A160E",
  "258": "677E93_36444D_99A9BA_435464",
  "259": "678E67_C4D9C4_ACC8AC_98B898",
  "260": "68049F_C90DE6_A404CF_B304DC",
  "261": "683F2D_9F736D_431D06_966152",
  "262": "68493E_B2AAA9_978C8C_130907",
  "263": "684C40_776E69_9B7765_758D96",
  "264": "685B57_BEB1B1_9B99A4_1E1D1D",
  "265": "686464_CCCAC7_A4A19F_BCB4B4",
  "266": "686B73_2A2B2D_D5D9DD_B0B3BC",
  "267": "686E55_353C2F_869B7F_444434",
  "268": "696347_98B0A2_28261E_362B22",
  "269": "696969_A0A0A0_949494_8C8C8C",
  "270": "6A3C15_EFC898_D59D59_B38346",
  "271": "6A5338_1C120B_C5975F_96886C",
  "272": "6A8287_405153_839EBE_424C5C",
  "273": "6B3822_A65D48_824E48_401E0C",
  "274": "6BBD6B_C8F3C8_A3E2A3_B4ECB4",
  "275": "6C52AA_C9A6EA_A681D6_B494E2",
  "276": "6C5DC3_352D66_5C4CAB_544CA5",
  "277": "6C6F76_CBD1D7_B2BDC7_A6B0BF",
  "278": "6C8996_14223F_B9DEDD_2E445C",
  "279": "6D1616_E6CDBA_DE2B24_230F0F",
  "280": "6D3B1C_895638_502A0D_844C31",
  "281": "6D6050_C8C2B9_A2998E_B4AA9F",
  "282": "6D6D6D_3E3E3E_C0C0C0_949494",
  "283": "6E2E36_D3A1A0_BD7175_C78C8B",
  "284": "6E5137_E8CA90_271912_B99C74",
  "285": "6E524D_8496C5_AF6624_100B11",
  "286": "6E6D69_D0ECE9_AAC7C6_200C0C",
  "287": "6E7181_D1CFDF_ABAFC7_B4BCCE",
  "288": "6E8C48_B8CDA7_344018_A8BC94",
  "289": "6EC66E_C9F8C9_A3E8A3_B4F1B4",
  "290": "6F503E_D59A70_221812_B0A899",
  "291": "705B4B_312821_AF927B_44342C",
  "292": "706962_24211E_BCB6AF_ACA494",
  "293": "713A28_A87661_3A160D_9B6454",
  "294": "714C30_EAD7C5_CC9265_E2B48F",
  "295": "716049_D1C8B9_3F160C_BAA6A9",
  "296": "71623B_ECDE8C_30250A_ABA69A",
  "297": "72625B_F0DFD0_D9BAA5_C3A595",
  "298": "726F5B_A09C88_8B8C7B_94907C",
  "299": "727167_2F2F2B_A3A6A2_44443C",
  "300": "728473_534C40_7BCEC8_7BB9B6",
  "301": "736655_D9D8D5_2F281F_B1AEAB",
  "302": "745359_BFAEA8_9B8384_AC9392",
  "303": "746761_291C19_AB9385_3C2B27",
  "304": "747A6F_292E2A_ACA79F_45453B",
  "305": "74A192_041B0D_194C33_235B4C",
  "306": "75322B_96463F_51201A_3D1814",
  "307": "75723E_C0C3A0_2A1E0E_AFAE77",
  "308": "75746F_333330_A2A1A9_444444",
  "309": "758391_BAC2CA_435263_A1ACBC",
  "310": "763B28_D0BDB8_ADA39E_1E1D1D",
  "311": "763C39_431510_210504_55241C",
  "312": "764739_D0917B_2A1611_B37C68",
  "313": "765938_1F1009_A59C7C_C9A382",
  "314": "766554_C1BEBB_2A1A0E_B4ABAC",
  "315": "76787C_2F3031_A5A9B8_444446",
  "316": "767989_323437_B6C4EE_343C44",
  "317": "771A1F_D2939E_B6595D_9D4B54",
  "318": "773012_AE5124_4D1908_340F04",
  "319": "776045_D2CCC3_281910_BBB5AA",
  "320": "776A5C_BA9A89_302C26_443C34",
  "321": "776C62_292622_474039_3C342C",
  "322": "777C61_333727_BABFA1_A5AC8C",
  "323": "777D7D_BDCAD2_3E3C2E_B1B8B6",
  "324": "787165_DAD9CD_9DC0CE_36302A",
  "325": "7877EE_D87FC5_75D9C7_1C78C0",
  "326": "794E40_361612_4C2A21_441B1B",
  "327": "795038_C2856B_533320_AC7C61",
  "328": "796D6B_DED3CB_C6BAB1_ADA09B",
  "329": "796F52_36413A_C9B48C_B6A77F",
  "330": "797367_302E29_ABA3A0_443C35",
  "331": "7A6959_2D271D_C1B5A9_B4A393",
  "332": "7A736F_463F33_575046_4B463D",
  "333": "7A7A7A_D0D0D0_BCBCBC_B4B4B4",
  "334": "7A7A7A_D9D9D9_BCBCBC_B4B4B4",
  "335": "7A7C63_625531_665B3F_5B4B29",
  "336": "7A9196_485C64_425459_C1E4E7",
  "337": "7B5254_E9DCC7_B19986_C8AC91",
  "338": "7B6857_383028_BCA38F_4C3C34",
  "339": "7B6E5B_C5CACC_B1B2AE_322415",
  "340": "7B7E82_343536_A0B1C8_44444C",
  "341": "7C584C_27140D_B3765C_3D2318",
  "342": "7C7C71_353630_ADAFAF_444444",
  "343": "7D6651_F8E3BF_CEA987_E7C29C",
  "344": "7D7673_353230_AEA7B0_4C4444",
  "345": "7DA1BA_A4CCE8_5D7A8B_5E7C94",
  "346": "7E5344_22120E_CCAB9C_8D919D",
  "347": "7E5E57_AD9794_612D1D_C9997D",
  "348": "7E8174_39444D_CECAA7_B3B49B",
  "349": "7F5134_22120A_452110_9F7D5F",
  "350": "7F8896_3B3936_BBCFE9_4B4B4D",
  "351": "803537_310F10_C35A5D_D89093",
  "352": "807068_C3B0AB_443E3B_AC9C94",
  "353": "80726C_DCDBD7_9AA6C2_B7BFCA",
  "354": "808A5B_E0E1D4_2C4304_C5C7B0",
  "355": "80A6B4_D5E9EF_B2D0D9_C1DCE4",
  "356": "80CA23_B7EE37_D5FA4C_A3E434",
  "357": "812828_521818_C94141_AB3737",
  "358": "812E39_551C24_381117_9E3C49",
  "359": "815C41_F6C99A_D39F77_BB9474",
  "360": "815F54_DECBC6_301813_C5A8A0",
  "361": "8194AB_D6DFEB_C0CEDE_B0BFD1",
  "362": "81ADB3_D6ECEE_BFDEE1_AFD1D7",
  "363": "81BABA_D5F3F3_BBE4E4_ABDCDC",
  "364": "825C4D_A08175_97746C_613B2F",
  "365": "826A59_E0C9B9_CBAD99_3D2615",
  "366": "827C87_4F3937_605457_534C4E",
  "367": "834741_4C281D_BE8F8C_AE6A65",
  "368": "835984_39273A_4C334C_593D5A",
  "369": "837667_DCD4C8_C5BAAC_3C2E22",
  "370": "846556_503E33_61493D_5C4434",
  "371": "848679_363630_AABBB7_4B4B44",
  "372": "855D08_DAC31B_BF9B0C_AF860C",
  "373": "85694C_D1A67A_3C2F22_EBBF8F",
  "374": "857B61_ACE5D4_593D28_5B4334",
  "375": "858362_9F9F80_9C9673_70714B",
  "376": "85B9D3_C9EAF9_417277_528789",
  "377": "866C5B_544237_B29B8C_AC8F7C",
  "378": "872F2D_AB403E_682421_581F1C",
  "379": "877B70_34302B_CBB3A4_524C44",
  "380": "877C72_B6ACBB_36322D_4C443B",
  "381": "878787_4C4C4C_646464_5C5C5C",
  "382": "887153_E5C188_433729_C1A484",
  "383": "888D8F_515454_646A6C_6C6C6D",
  "384": "89204B_17080D_DA4377_F780B5",
  "385": "8955D0_744CC4_EA4AEF_954DA4",
  "386": "8A3B3D_DA5F62_461F20_BC7F81",
  "387": "8A3DA1_D77CE4_C263D4_B75AC9",
  "388": "8A5B34_F3BD7C_DA9758_BE7E45",
  "389": "8A6565_2E214D_D48A5F_ADA59C",
  "390": "8A7666_3C332C_C6AEA2_54443C",
  "391": "8A7968_3C342D_C6B3A5_54443B",
  "392": "8B7469_443E39_C7A797_544443",
  "393": "8B795F_291504_EFE5D4_4A3518",
  "394": "8B892C_D4E856_475E2D_47360A",
  "395": "8C5945_D4C0B6_C3A49C_430504",
  "396": "8CAEBC_3A4443_506463_DAEFEF",
  "397": "8D553D_3C2419_5D3727_AA766C",
  "398": "8D8D8D_DDDDDD_CCCCCC_B7B7B7",
  "399": "8E6767_D9C4C4_C8ACAC_B89898",
  "400": "8E7C67_E2C6A5_3B332A_C3AB94",
  "401": "8E907C_B1B5A7_D7DBD0_CCCFBA",
  "402": "8F4277_361530_BF538E_52274C",
  "403": "8F4E20_E8B06B_391A08_CC8944",
  "404": "8F5D3C_5B3B26_382416_70482E",
  "405": "8F7B61_D6B892_4E4436_C3AC86",
  "406": "8F894E_DAD79B_C9C384_C4BE7B",
  "407": "903B2A_EC9888_D96747_58190D",
  "408": "906867_C7B6BC_5D2E26_BEA4A3",
  "409": "908887_3C3229_C7C6D0_554A45",
  "410": "908E8E_292828_454444_595757",
  "411": "909473_555D4B_C2CCA2_645B3C",
  "412": "910E5A_E127C3_CF1CA3_C1158F",
  "413": "926B48_4C2D0D_5F3913_AA8874",
  "414": "927253_EECEA7_D8B792_C7A883",
  "415": "935555_F6DAD9_D39393_593333",
  "416": "936451_C29A8F_5F3A2B_361D14",
  "417": "938C8D_403731_CECED8_554C4C",
  "418": "942967_D292B5_C76E9E_551A4C",
  "419": "945D43_E5AAA0_351F14_CC8B78",
  "420": "94615B_DACED1_C3B9A4_CCABAA",
  "421": "94624F_573529_24110C_733424",
  "422": "9650CA_46236A_7239A6_633492",
  "423": "965146_2B191D_DF7A5C_BFD6E1",
  "424": "96785D_B8A398_63452C_6C5435",
  "425": "975337_EEBE98_4B211C_D88659",
  "426": "977970_E1D9D8_DAC8C1_C4B2AD",
  "427": "98332E_4A100D_691A16_A85A5B",
  "428": "989784_665542_BFECE5_6D644C",
  "429": "9A5A55_31110D_582A24_703C34",
  "430": "9A7467_D2C2BF_662D22_CCB2A5",
  "431": "9AA8B6_313133_4E5055_D7EBF8",
  "432": "9B4816_E8A138_CC7421_DC8827",
  "433": "9B9994_E1E0DB_474643_544C4C",
  "434": "9B9B9B_1E1E1E_5C5C5C_444444",
  "435": "9C5B3B_49200A_E9C8AB_DDAB7D",
  "436": "9CC338_4E671A_799F27_8CAC2C",
  "437": "9D282A_38191D_DFC6CD_D6495A",
  "438": "9D4343_E38989_D37474_CE6C6C",
  "439": "9D602E_E4C363_D5A64F_C38A44",
  "440": "9D7F6E_C6DAD4_6D4C4B_C6BBBC",
  "441": "9D8F84_5D4544_D9D3C9_62555A",
  "442": "9D9D9D_4E4E4E_646464_6C6C6C",
  "443": "9E7C7E_DDCBD0_351D20_683B38",
  "444": "9E9C77_6E6F4E_7C7C54_C7BF96",
  "445": "9F1A27_F1AF7F_CD5845_D08441",
  "446": "9F4738_CE958D_4F0C0A_C0837C",
  "447": "9F7D30_B69F75_B9B7BE_CB9C4D",
  "448": "9F886D_362F25_E8C9A4_5C4C3C",
  "449": "9F9F9F_E4E4E4_D4D4D4_CCCCCC",
  "450": "A05F31_D5C2BC_D9996F_42230E",
  "451": "A0A8B0_424336_E7E9EF_545C5C",
  "452": "A1824F_4A2A06_F7E29F_B3A598",
  "453": "A27216_E9D036_D0AB24_DCB927",
  "454": "A28766_E4D6C3_D6C4AA_CAB598",
  "455": "A3B2A4_3B3E3D_676F6A_535C57",
  "456": "A48DA4_E8DDE8_C9B7C9_D4C2D4",
  "457": "A49994_695244_C4C2CF_76645C",
  "458": "A67362_36150C_5E2E1E_F6C3BF",
  "459": "A84337_611D18_3F110F_7C2A22",
  "460": "A88C77_DAD2C7_623532_956229",
  "461": "A95E4D_57261A_6E3223_773C24",
  "462": "A971A9_E8CBE8_D4A8D4_DCB3DC",
  "463": "A98D6A_F2D3AB_FBE6BE_695332",
  "464": "A9A2A0_2F211C_544440_6D5E5A",
  "465": "AA526C_EAA6C9_DC88AF_D17BA0",
  "466": "AB2C2C_EBB4B3_561212_DE8484",
  "467": "AB2D08_C35E5A_C75522_C56C70",
  "468": "AB54A8_EBAAE9_DF8FDD_D37ED0",
  "469": "AC171C_FA8593_E84854_D3464E",
  "470": "AC725C_2E1610_663E31_E78F6B",
  "471": "AC7F84_78463A_C4AABB_885454",
  "472": "AC8942_432D19_6E4D27_5F3B1C",
  "473": "AC8961_EBDAC3_D1B791_DCC2A0",
  "474": "AD9E81_F1E5CE_6B5C3E_5A492A",
  "475": "ADC2CD_DFF7FA_C9E6F5_C1DBEC",
  "476": "AE9D99_29303B_585F70_875C33",
  "477": "AF986F_CDB489_9C7C5B_7E6C4D",
  "478": "AF987A_2F2416_523F27_6B5331",
  "479": "AF9A72_504718_74652B_E2C2A2",
  "480": "B06932_451B09_7B3E16_150804",
  "481": "B09273_7A573D_C7AF97_84644C",
  "482": "B0A2A8_866A63_E8E9F2_614C4F",
  "483": "B0B0B0_6E6E6E_848484_8C8C8C",
  "484": "B1A395_EFE6E1_635A47_786D5D",
  "485": "B2674B_552913_7C442F_733919",
  "486": "B26F52_4B2E2B_79493A_663B32",
  "487": "B27744_5A2804_F6C488_EBB27D",
  "488": "B38B76_40251D_745042_5F3A30",
  "489": "B3AA93_F4EFD7_E1DDC2_DCD3BB",
  "490": "B47A5B_301E14_704A31_633C23",
  "491": "B4B29D_442D0D_604E2A_736542",
  "492": "B5987E_F8E4DC_6F5939_E9CCBA",
  "493": "B5BBB5_3B4026_6E745D_5C6147",
  "494": "B62D33_E4868B_7E2D34_DD6469",
  "495": "B66D59_F0C9B2_E5B49C_DAA084",
  "496": "B67F6B_4B2E2A_6C3A34_F3DBC6",
  "497": "B6B8B1_994A24_315C81_927963",
  "498": "B76E5E_7F3A2F_EE938C_F8A5A1",
  "499": "B7A763_E6E1CC_554A1E_6C6428",
  "500": "B86137_FBCA6F_6F3C37_040404",
  "501": "B9896A_5B341B_F4CAA3_6C4C2D",
  "502": "B98A6D_7B4F38_D1A68F_8C5B43",
  "503": "B9B37A_F1EED0_E5E4BA_DAD6A8",
  "504": "B9CDD2_775339_958272_7F6A5E",
  "505": "BA472D_CA6E67_C76150_CA6C59",
  "506": "BA5DBA_F2BEF2_E69BE6_DC8CDC",
  "507": "BA864A_5D381E_644422_FBE97A",
  "508": "BA8979_DDCBCA_9A4726_892407",
  "509": "BAADA8_ECE6E7_9A8378_E3DCD3",
  "510": "BC5B43_95170B_EEAC92_DB8C7C",
  "511": "BC928D_F9E2D6_654445_835A51",
  "512": "BD0D0D_970404_7B0404_550404",
  "513": "BD5345_460F11_732622_EDB7B1",
  "514": "BDB466_F3EDC3_E3DD9F_ECE3AA",
  "515": "BE5F5F_F4BDBD_ECA4A4_E29191",
  "516": "BEE2E9_7E6A53_9AA09C_87837E",
  "517": "BF7051_994C2D_E99A7B_DE8C74",
  "518": "BF7745_F5D08E_E5AE6B_ECBC7C",
  "519": "BF8E78_E5CCBF_753E32_4A261E",
  "520": "BFAA83_F5EAD6_E1D0B1_EBDDC0",
  "521": "BFB5A4_DEDCCB_D7D4CC_DCD3C2",
  "522": "C05429_ED6129_94492A_834729",
  "523": "C09E5C_DAD2B9_654429_81582D",
  "524": "C1AA92_AD6E29_737889_CED1D7",
  "525": "C1B3A1_F6EEE5_E1D7C7_ECE4D3",
  "526": "C21338_920C24_E71C54_F34A7D",
  "527": "C28E4E_845119_0B0805_713C0C",
  "528": "C2A391_523728_785741_694836",
  "529": "C2A584_363B41_71665B_8C7367",
  "530": "C2AB7D_4A412E_7A6B4E_F9EDBE",
  "531": "C30C0C_9F0404_830404_5C0404",
  "532": "C33829_48171A_752523_942923",
  "533": "C345EC_5F1DAA_9F31DB_872CCD",
  "534": "C35C04_F9C30C_EE9F04_E08304",
  "535": "C3CCD4_5F3B23_948A7B_A9A49A",
  "536": "C47004_F9D00C_EDAF04_E09704",
  "537": "C4A591_635448_F2D9D5_856D5B",
  "538": "C4C6C6_4D5756_646463_7A8080",
  "539": "C4DEDE_97B5B5_EAF9F9_ABC4C4",
  "540": "C5A292_635247_F2D7D6_846A5B",
  "541": "C5BBB6_F8F4F1_E2DAD6_ECE3DF",
  "542": "C75F55_F8BDA9_EB9484_F4A494",
  "543": "C7938D_E0DBE1_D1BBBC_D5CCCB",
  "544": "C7B9A1_F8F1E4_EEE4D2_E4D8C4",
  "545": "C7C0AC_2E181B_543B30_6B6270",
  "546": "C7C7D7_4C4E5A_818393_6C6C74",
  "547": "C87157_F8CBAE_E9A582_F2B394",
  "548": "C88467_5B3333_875C5A_7A3822",
  "549": "C8AF84_F9ECD7_EFDEBF_E6D1AF",
  "550": "C8C8C8_3F3F3F_787878_5C5C5C",
  "551": "C8D1DC_575B62_818892_6E747B",
  "552": "C98D7F_3B0B0B_A97667_94433F",
  "553": "C99A8B_491B0E_6E4136_8A4D28",
  "554": "C9C7BE_55514B_888279_7B6E5F",
  "555": "CA4FE1_6B2398_A337C7_9334BC",
  "556": "CA8892_F9D7DC_EBB8C0_F3C4CC",
  "557": "CAA094_875343_956255_EADEDC",
  "558": "CAA78A_F9E7D7_EAD0B9_F3DCC3",
  "559": "CAAC80_FAEBD5_F2DEBF_EAD1AF",
  "560": "CAB094_F9ECDD_EFDEC8_E8D4BD",
  "561": "CAB79D_F9F1E3_F1E5D1_E9DAC6",
  "562": "CAE24E_6C9A23_A3C737_B3D43C",
  "563": "CB4934_FB9971_F07554_F68464",
  "564": "CB4E88_F99AD6_F384C3_ED75B9",
  "565": "CB5E3B_FABC7A_EF965E_F4A46C",
  "566": "CB7146_551D0F_7C270D_E5AB9C",
  "567": "CB7846_753C22_AB5C32_B46C3C",
  "568": "CB919B_F9DDE1_ECC0C8_F4CCD4",
  "569": "CBCBCB_595959_8C8C8C_747474",
  "570": "CC7C5F_A15436_B26346_AF5C3C",
  "571": "CC9A7E_8A5249_C06A3E_DADADA",
  "572": "CCC5C9_3B2B2B_67585B_7F7375",
  "573": "CCF6FA_9DD9EB_82C5D9_ACD4E4",
  "574": "CDC3B8_5A3F3C_67545A_8D7769",
  "575": "CDCBC8_444342_696765_81807E",
  "576": "CE8C15_EAC79B_DDAB57_F9C962",
  "577": "CE8F3D_F0D2B0_F3C77D_E6B278",
  "578": "CEB299_6B5C4C_887564_746355",
  "579": "D04444_AF2F2F_8B2424_9B2C2C",
  "580": "D07E3F_FBBD1F_8D2840_24120C",
  "581": "D0CCCB_524D50_928891_727581",
  "582": "D0D3BE_816854_998366_685146",
  "583": "D1AC04_F8E50A_EDD004_B38D04",
  "584": "D3CAAB_8C866E_C0B89A_AEA68A",
  "585": "D4855F_92512D_AE6742_A75C2C",
  "586": "D54C2B_5F1105_F39382_F08375",
  "587": "D5B5B4_9E6C6F_F5E9EF_A57986",
  "588": "D5D5D5_929292_ACACAC_B4B4B4",
  "589": "D64480_E27497_EA9BB1_CD156F",
  "590": "D7D7C3_AAAA92_F5F5EA_BCBCA4",
  "591": "D7DFDB_AAB5AF_F5FAF7_BCC4C4",
  "592": "D8388B_230A14_FCC8FC_FC71E1",
  "593": "D8C949_F5F19E_6B7855_9A9858",
  "594": "D8D8E5_9D9DAF_B4B4C4_B4B4CC",
  "595": "DA5788_DE94BD_E078A3_DD83B4",
  "596": "DBDBBB_F7F7E4_AFAF89_C4C49C",
  "597": "DC3E04_B52604_FC7D20_F85F04",
  "598": "DE9261_86361E_A85A37_944C2C",
  "599": "DEDEC4_B5B597_F9F9EA_C4C4AB",
  "600": "DEE3E8_A6AEB5_BCC4CC_BCC4C4",
  "601": "DEE8DE_A6B5A6_BCCCBC_BCC4BC",
  "602": "DEE8E8_A6B5B5_BCCCCC_BAC4C4",
  "603": "DFD9C2_B5AE92_F9F7EA_C4C4A4",
  "604": "DFDBB7_F9F8E3_B5AF86_BCBC8C",
  "605": "DFDFCA_4D2D07_6B5224_857145",
  "606": "DFDFD6_58544E_81766A_989288",
  "607": "E1E1D4_777C7B_9FA19A_898F8D",
  "608": "E1E1E0_363636_989897_747472",
  "609": "E2D3BC_867255_B39E7F_96836C",
  "610": "E2E2E7_AEAEB5_C4C4CC_C4C4C4",
  "611": "E42E12_F35132_F86949_B71B0A",
  "612": "E5DED7_AFA69D_C4BCB4_C3BAAB",
  "613": "E6BF3C_5A4719_977726_FCFC82",
  "614": "E6E3E3_B5AFAF_CCC4C4_C4C4C4",
  "615": "E6E6E6_AAAAAA_C4C4C4_CCCCCC",
  "616": "E7632F_FBA06B_BB2905_FB865E",
  "617": "E7E2D8_B1AA9D_C9C2B3_BCB4AC",
  "618": "E80404_B50404_CB0404_FC3333",
  "619": "E804E8_B504B5_CC04CC_FC33FC",
  "620": "E8DEE1_B5A6AA_CCBCC1_C4BBBC",
  "621": "E8E5DE_B5AFA6_CCC5BC_C4C4BB",
  "622": "E8E8DE_B5B5A6_CCCCBC_C4C4BA",
  "623": "E9CCA1_A63106_DF8C3B_621304",
  "624": "EA783E_6D4830_905837_FCDC6C",
  "625": "EAD8D6_B59A97_CCB4B0_C9ABAB",
  "626": "EAEAEA_B5B5B5_CCCCCC_D4D4D4",
  "627": "EAEAEA_B6B6B6_CCCCCC_C4C4C4",
  "628": "ED4630_791A0E_A42716_501009",
  "629": "ED5087_FAC3D0_1C0B0C_FC84CC",
  "630": "ED7F04_FCD60E_7E2D04_B73E04",
  "631": "EDED06_B5B504_CCCC04_D4D404",
  "632": "EE4128_FC8E82_9A0704_BF0F05",
  "633": "EEECFB_BFB6D5_D0C8EB_CCC4DC",
  "634": "F0D504_FBFAD3_B98609_CDA204",
  "635": "F75F0B_461604_9A3004_FB9D2F",
  "636": "F77777_FBE1E1_FAB2B2_FBC4C4",
  "637": "F79686_FCCBD4_E76644_E76B56",
  "638": "F9E6C7_FCF7DF_EDD3AA_F1D4B4",
  "639": "FBB43F_FBE993_FB552E_FCDD65",
  "640": "FBB82D_FBEDBF_FBDE7D_FB7E05"
};

function getFormatString(format) {
  switch (format) {
    case 64:
      return '-64px';

    case 128:
      return '-128px';

    case 256:
      return '-256px';

    case 512:
      return '-512px';

    default:
      return '';
  }
}

var MATCAP_ROOT = 'https://rawcdn.githack.com/emmelleppi/matcaps/9b36ccaaf0a24881a39062d05566c9e92be4aa0d';
var DEFAULT_MATCAP = matcapList[0];

function useMatcapTexture() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1024;
  var numTot = useMemo(function () {
    return Object.keys(matcapList).length;
  }, []);
  var fileHash = useMemo(function () {
    if (typeof id === 'string') {
      return id;
    } else if (typeof id === 'number') {
      return matcapList[id];
    }

    return null;
  }, [id]);
  var fileName = "" + (fileHash || DEFAULT_MATCAP) + getFormatString(format) + ".png";
  var url = MATCAP_ROOT + "/" + format + "/" + fileName;
  var matcapTexture = useTexture(url);
  return [matcapTexture, url, numTot];
}

var normalsList = {
  "0": "151_norm.JPG",
  "1": "152_norm.JPG",
  "2": "153_norm.JPG",
  "3": "154_norm.JPG",
  "4": "155_norm.JPG",
  "5": "156_norm.JPG",
  "6": "157_norm.JPG",
  "7": "158_norm.JPG",
  "8": "159_norm.JPG",
  "9": "160_norm.JPG",
  "10": "161_norm.JPG",
  "11": "162_norm.JPG",
  "12": "163_norm.JPG",
  "13": "164_norm.JPG",
  "14": "165_norm.JPG",
  "15": "166_norm.JPG",
  "16": "167_norm.JPG",
  "17": "168_norm.JPG",
  "18": "169_norm.JPG",
  "19": "170_norm.JPG",
  "20": "171_norm.JPG",
  "21": "172_norm.JPG",
  "22": "173_norm.JPG",
  "23": "174_norm.jpg",
  "24": "175_norm.JPG",
  "25": "176_norm.JPG",
  "26": "177_norm.JPG",
  "27": "178_norm.JPG",
  "28": "179_norm.JPG",
  "29": "180_norm.JPG",
  "30": "181_norm.JPG",
  "31": "182_norm.JPG",
  "32": "183_norm.JPG",
  "33": "184_norm.JPG",
  "34": "185_norm.JPG",
  "35": "186_norm.JPG",
  "36": "187_norm.JPG",
  "37": "188_norm.JPG",
  "38": "189_norm.JPG",
  "39": "190_norm.JPG",
  "40": "191_norm.JPG",
  "41": "192_norm.JPG",
  "42": "193_norm.JPG",
  "43": "194_norm.JPG",
  "44": "195_norm.JPG",
  "45": "196_norm.JPG",
  "46": "197_norm.JPG",
  "47": "198_norm.JPG",
  "48": "199_norm.JPG",
  "49": "200_norm.JPG",
  "50": "201_norm.jpg",
  "51": "202_norm.jpg",
  "52": "203_norm.jpg",
  "53": "204_norm.jpg",
  "54": "205_norm.jpg",
  "55": "206_norm.jpg",
  "56": "207_norm.jpg",
  "57": "208_norm.jpg",
  "58": "209_norm.jpg",
  "59": "210_norm.jpg",
  "60": "211_norm.jpg",
  "61": "212_norm.jpg",
  "62": "213_norm.jpg",
  "63": "214_norm.jpg",
  "64": "215_norm.jpg",
  "65": "216_norm.jpg",
  "66": "217_norm.jpg",
  "67": "218_norm.jpg",
  "68": "219_norm.jpg",
  "69": "220_norm.jpg",
  "70": "221_norm.jpg",
  "71": "222_norm.jpg",
  "72": "223_norm.jpg",
  "73": "224_norm.jpg",
  "74": "225_norm.jpg",
  "75": "226_norm.jpg"
};
var NORMAL_ROOT = 'https://rawcdn.githack.com/emmelleppi/normal-maps/f24c810fc1d86b5b1e5dfea914b668f70b5f2923';
var DEFAULT_NORMAL = normalsList[0];

function useNormalTexture() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _ref16 = arguments.length > 1 ? arguments[1] : undefined,
      _ref16$repeat = _ref16.repeat,
      repeat = _ref16$repeat === void 0 ? [1, 1] : _ref16$repeat,
      _ref16$anisotropy = _ref16.anisotropy,
      anisotropy = _ref16$anisotropy === void 0 ? 1 : _ref16$anisotropy,
      _ref16$offset = _ref16.offset,
      offset = _ref16$offset === void 0 ? [0, 0] : _ref16$offset;

  var numTot = useMemo(function () {
    return Object.keys(normalsList).length;
  }, []);
  var imageName = normalsList[id] || DEFAULT_NORMAL;
  var url = NORMAL_ROOT + "/normals/" + imageName; // @ts-expect-error

  var normalTexture = useTexture(url);
  useEffect(function () {
    if (!normalTexture) return;
    normalTexture.wrapS = normalTexture.wrapT = RepeatWrapping;
    normalTexture.repeat = new Vector2(repeat[0], repeat[1]);
    normalTexture.offset = new Vector2(offset[0], offset[1]);
    normalTexture.anisotropy = anisotropy;
  }, [normalTexture, anisotropy, repeat, offset]);
  return [normalTexture, url, numTot];
}

export { Billboard, Box, Circle, Cone, ContactShadows, Cylinder, Detailed, DeviceOrientationControls, Dodecahedron, Effects, Environment, Extrude, FlyControls, HTML, Html, Icosahedron, Lathe, Line, Loader, MapControls, MeshDistortMaterial, MeshWobbleMaterial, Octahedron, OrbitControls, OrthographicCamera, Parametric, PerspectiveCamera, Plane, PointerLockControls, Polyhedron, PositionalAudio, Reflector, Ring, RoundedBox, Shadow, Sky, Sphere, Stars, Stats, Tetrahedron, Text, Torus, TorusKnot, TrackballControls, TransformControls, Tube, calcPosFromAngles, isWebGL2Available, meshBounds, shaderMaterial, softShadows, useAspect, useCamera, useContextBridge, useCubeTexture, useDetectGPU, useFBX, useGLTF, useHelper, useMatcapTexture, useNormalTexture, useProgress, useSimplification, useSubdivision, useTessellation, useTexture };